// ---------------------------
// ---------------------------
// Webfont loader
// ---------------------------
// ---------------------------
WebFontConfig = {
  google: {
    families: [
      "Montserrat:400,400i,500,500i,600,600i,700,700i,900",
      "Source Sans Pro:400,400i,600,600i,700,700i,900"
    ]
  }
};

(function(d) {
  var wf = d.createElement('script'), s = d.scripts[0];
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.async = true;
  s.parentNode.insertBefore(wf, s);
})(document);


// ---------------------------
// ---------------------------
// Website core
// ---------------------------
// ---------------------------

// Constants
var $window, $body, $header, arrBootStack = [];

$(document).on("ready", initialize);
function initialize() {
  // Set constants
  window.$window = $(window);
  window.$body = $("body");
  window.$header = $("header");

  // $(".body-frame").removeClass("body-frame-transition-exit");

  // Initialize classes
  for(var i=0; i < arrBootStack.length; i++) {
    arrBootStack[i].initialize();
  }

  // Fix transition problem when using back button on safari
  $(window).bind("pageshow", function(event) {
    $(".body-frame").removeClass("body-frame-transition-exit");
    if (event.originalEvent.persisted) {
      window.location.reload()
    }
  });
}

$(window).on("load", loaded);
function loaded() {
  // Trigger window resize and scroll only once
  window.$window.trigger("scroll");
  window.$window.trigger("resize");
}
// ---------------------------
// ---------------------------
// Helpers
// ---------------------------
// ---------------------------
// Check if the body has a class(es)
//
// @return Boolean
function is_page(body_classes) {
  return $body.hasClass(body_classes);
}


// Convert an object to base64 string
//
// @return String
function json_to_base64(json) {
  var json_string = JSON.stringify(json);
  return btoa(json_string);
}


// Converte base64 string to an object
//
// @return Object
function base64_to_json(base64) {
  var json_string = atob(base64);
  return JSON.parse(json_string);
}


// Return Query string value
//
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


// Basic sprinft method working only with %s
//
// @return String
function sprintf(format, etc) {
  var arg = arguments,
      i = 1;
  return format.replace(/%((%)|s)/g, function (m) { return m[2] || arg[i++] })
}



// Set cookie
//
function setCookie(cookie_name, value, expiration_days) {
  var expiration_date = new Date();
  expiration_date.setDate(expiration_date.getDate() + expiration_days);

  var cookie_value = escape(value) + ((expiration_days == null) ? "" : "; expires=" + expiration_date.toUTCString())+"; path=/";
  document.cookie = cookie_name + "=" + cookie_value;
}

// Read cookies
//
function getCookie(cookie_name) {
  var cookie_value = document.cookie;
  var cookie_start = cookie_value.indexOf(" " + cookie_name + "=");

  if (cookie_start == -1) cookie_start = cookie_value.indexOf(cookie_name + "=");

  if (cookie_start == -1) {
    cookie_value = null;
  }else{
    cookie_start = cookie_value.indexOf("=", cookie_start) + 1;
    var c_end = cookie_value.indexOf(";", cookie_start);

    if (c_end == -1) c_end = cookie_value.length;

    cookie_value = unescape(cookie_value.substring(cookie_start,c_end));
  }

  return cookie_value;
}

// Scroll to an element
//
function scrollToElement(e) {
  e.preventDefault();
  var $target = $($(e.currentTarget).attr("href"));
  scrollToTarget($target, $(e.currentTarget));
}

// Scroll to a target
//
function scrollToTarget($target, $current) {
  var headerHeight = $header.outerHeight();

  if($current && $current.is(".secondary-navigation a")) {
    headerHeight += 15;
  }

  $("html, body").animate({
    scrollTop: ($target.offset().top - headerHeight),
  }, 500);
}


// Init same-height for a batch of element
//
// @return Void
function sameHeight($objects, startAt, endAt, heightType, callback) {
  startAt = typeof startAt == "undefined" ? 99999 : startAt;
  endAt = typeof endAt == "undefined" ? 0 : endAt;
  heightType = typeof heightType == "undefined" ? "height" : heightType;

  $window.on("resize", {cachedObjects: $objects, startAt: startAt, endAt: endAt, heightType: heightType, callback: callback}, function(e) {
    var $cachedObjects = e.data.cachedObjects;
    var startAt = e.data.startAt;
    var endAt = e.data.endAt;
    var heightType = e.data.heightType;

    if($window.width() <= startAt && $window.width() > endAt) {
      sameHeightSet($cachedObjects, heightType);
      var data_callback = "enable";
    }else{
      $cachedObjects.css({minHeight: 0});
      var data_callback = "disabled";
    }

    // Callback for extra works
    if(typeof e.data.callback != "undefined") {
      e.data.callback(data_callback);
    }
  });
}

// Set same-height for a batch of cached elements
//
// @return Void
function sameHeightSet($cachedObjects, heightType) {
  var max = -1;
  var h = 0;

  $cachedObjects.css({minHeight: 0});
  $cachedObjects.each(function() {
    h = heightType == "outerHeight" ? $(this).outerHeight() : $(this).height();
    max = h > max ? h : max;
  });

  $cachedObjects.css({minHeight: max});
}

// Init same-width for a batch of element
//
// @return Void
function sameWidth($objects, startAt, endAt, widthType, callback) {
  startAt = typeof startAt == "undefined" ? 99999 : startAt;
  endAt = typeof endAt == "undefined" ? 0 : endAt;
  widthType = typeof widthType == "undefined" ? "width" : widthType;

  $window.on("resize", {cachedObjects: $objects, startAt: startAt, endAt: endAt, widthType: widthType, callback: callback}, function(e) {
    var $cachedObjects = e.data.cachedObjects;
    var startAt = e.data.startAt;
    var endAt = e.data.endAt;
    var widthType = e.data.widthType;

    if($window.width() <= startAt && $window.width() >= endAt) {
      sameWidthSet($cachedObjects, widthType);
      var data_callback = "enable";
    }else{
      $cachedObjects.css({minWidth: 0});
      var data_callback = "disabled";
    }

    // Callback for extra works
    if(typeof e.data.callback != "undefined") {
      e.data.callback(data_callback);
    }
  });
}

// Set same-width for a batch of cached elements
//
// @return Void
function sameWidthSet($cachedObjects, widthType) {
  var max = -1;
  var h = 0;

  $cachedObjects.css({minWidth: 0});
  $cachedObjects.each(function() {
    h = widthType == "outerWidth" ? $(this).outerWidth() : $(this).width();
    max = h > max ? h : max;
  });

  $cachedObjects.css({minWidth: max});
}


// Target first link in the parent
//
function redirectToChildrenLink(e) {
  var $el = $(e.currentTarget);
  var $links = $el.find("a");

  if($links.length > 0) {
    if($links.first().attr("target") == "_blank") {
      window.open($links.first().attr("href"),'_blank');
    }else{
      window.location = $links.first().attr("href");
    }
  }
}


// Find hidden element height
//
function find_hidden_height($element) {
  return $element[0].scrollHeight;
}


// Returns a random integer between min (inclusive) and max (inclusive)
// Using Math.round() will give you a non-uniform distribution!
//
// @return Integer
function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}



// Time to read a text adapted from this source code : https://github.com/ngryman/reading-time/blob/master/lib/reading-time.js
//
// @return Object
function readingTime(text, options) {
  function ansiWordBound(c) {
    return (
      (' ' === c) ||
      ('\n' === c) ||
      ('\r' === c) ||
      ('\t' === c)
    )
  }

  var words = 0, start = 0, end = text.length - 1, wordBound, i

  options = options || {}

  // use default values if necessary
  options.wordsPerMinute = options.wordsPerMinute || 200

  // use provided function if available
  wordBound = options.wordBound || ansiWordBound

  // fetch bounds
  while (wordBound(text[start])) start++
  while (wordBound(text[end])) end--

  // calculate the number of words
  for (i = start; i <= end;) {
    for (; i <= end && !wordBound(text[i]); i++) ;
    words++
    for (; i <= end && wordBound(text[i]); i++) ;
  }

  // reading time stats
  var minutes = words / options.wordsPerMinute
  var time = minutes * 60 * 1000
  var displayed = Math.ceil(minutes.toFixed(2))

  return {
    text: displayed + ' min read',
    minutes: minutes,
    time: time,
    words: words
  }
}

// Find component full width breakpoint based on gridle classes
//
// @return Integer
function griddleClassToFullWidthBreakpoint(classes) {
  if(classes.indexOf("gr-24@tv") != -1) {
    return 1600;
  }else if(classes.indexOf("gr-24@desktop") != -1) {
    return 1300;
  }else if(classes.indexOf("gr-24@tablet") != -1) {
    return 1024;
  }else if(classes.indexOf("gr-24@mobile-large") != -1) {
    return 900;
  }else if(classes.indexOf("gr-24@mobile") != -1) {
    return 640;
  }else if(classes.indexOf("gr-24@mobile-small") != -1) {
    return 400;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);

  function initStepsTable() {
    var steps = document.querySelectorAll('.approach');

    steps.forEach(function(step) {
      ScrollTrigger.create({
        trigger: step,
        start: "top-=10% 40%",
        end: "bottom-=1% center",
        pin: step.querySelector('.approach-fixed-wrapper'),
        scrub: true,
        markers: false,
        pinSpacing: false,
      });
    });
  }

  function checkWidthAndInitSteps() {
    if (window.innerWidth >= 1024) {
      initStepsTable();
    } else {
      ScrollTrigger.getAll().forEach(function(trigger) {
        trigger.kill();
      });
    }
  }

  window.addEventListener('resize', checkWidthAndInitSteps);
  window.addEventListener('load', checkWidthAndInitSteps);
});
// This class handle «achievement introduction» component
//
var AchievementIntroduction = new function() {
  var _self = this,
      $achievementIntroductions = [];

  this.initialize = function () {
    $achievementIntroductions = $(".custom-section.achievement-introduction");

    if($achievementIntroductions.length > 0) {
      var $achievementImageWrapper = $achievementIntroductions.find(".achievement-introduction-slides-wrapper");
      if($achievementImageWrapper.hasClass("achievement-introduction-slides-wrapper-single")) {
        // Single pictures
        if(window.$window.width() > 850 && window.$window.height() > $achievementImageWrapper.find(".inner-content").outerHeight()) {
          var slideshow_height = window.$window.height() - $(".leonard-meta-nav").outerHeight() - 6;

          $achievementImageWrapper.css("minHeight", slideshow_height);
        }else{
          $achievementImageWrapper.css("minHeight", null);
        }
      }else{
        const fraction = document.getElementById("fraction");
        const slides = document.querySelectorAll(".swiper-slide");
        const slideCount = slides.length;
        fraction.textContent = "1 / " + slideCount;

        // Multiple pictures
        const swiper = new Swiper(".achievement-introduction-slides", {
          autoplay: {
            delay: 5000,
          },
          loop: true,
          pagination: {
            el: ".achievement-introduction-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: ".achievement-introduction-button-next",
            prevEl: ".achievement-introduction-button-prev",
          },
        });

        setInterval(function(){
          var activeSlide = document.querySelector(".swiper-slide-active");
          var slideNumber = parseInt(activeSlide.getAttribute('data-swiper-slide-index'));
          fraction.textContent = (slideNumber+1) + " / " + slideCount;
        }, '1000');
      }

      $achievementIntroductions.find(".row").each(function() {
        var $divs = $(this).find("> div");
        sameHeight($divs, 9999, 1009, "outerHeight");
      });

      sameHeight($(".achievement-introduction-introduction-content > div > div"), 9999, 1024, "outerHeight");

      $(".achievement-introduction-introduction-content li a").on('mouseover', listLinkOnMouseHover);
      $(".achievement-introduction-introduction-content li a").on('mouseout', listLinkOnMouseBlur);
    }
  }


  function listLinkOnMouseHover() {
    $(this).parent().addClass('hover');
  }

  function listLinkOnMouseBlur() {
    $(this).parent().removeClass('hover');
  }

}

// Push class in bootstack
arrBootStack.push(AchievementIntroduction);
// This class handle «blocks» component
//
var Blocks = new function() {
  var _self = this,
      $blocks;

  this.initialize = function () {
    $blocks = $(".custom-section.blocks");

    if($blocks.length > 0) {
      window.$window.on("scroll", handleBlockVisiblity);
    }
  }


  // Handle blocks visibility on scroll
  //
  function handleBlockVisiblity(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height() - (window.$window.height() / 5);

    $blocks.filter(":not(.visible)").each(function() {
      var $block = $(this);
      if($block.offset().top < scroll_bottom) {
        $block.addClass("visible");
      }
    });
  }


}

// Push class in bootstack
arrBootStack.push(Blocks);
// This class handle blog components
//
var Blog = new function() {
  var _self = this,
      $blogPostContent;

  this.initialize = function () {
    if(is_page("is-blog-page")) {
      // Add reading time estimation
      // -------
      var $readingTimeIndicator = $(".reading-time");
      if($readingTimeIndicator.length > 0) {
        var article_readtime = readingTime($(".first-letter-bigger").text());
        var minute_round = Math.ceil(article_readtime.minutes);

        if(minute_round <= 1) {
          $readingTimeIndicator.find("span").text(minute_round + " minute");
        }else{
          $readingTimeIndicator.find("span").text(minute_round + " minutes");
        }
      }

      // Hanging Box 
      // --------
      if($('.long-hanging').length){
        if($('.long-hanging').parent().is(":last-child")){
          $('.long-hanging-box').css('margin-bottom', '-20%');
          $('.long-hanging').closest( "section" ).css('margin-bottom', '25%');
        }
        else{
          $('.long-hanging').css('margin-bottom', '50px');
        }
      }

      if($('.long-block-statistic').length){
        if($('.long-block-statistic').parent().is(":last-child")){
          window.$window.on("resize", setHangingStatistic);
          $('.long-block-statistic').closest( "section" ).css('margin-bottom', '25%');
          if(window.$window.width() > 750) {
            $('.long-statistic-text').css('margin-bottom', '-20%');
          }
          else{
            $('.long-statistic-text').css('margin-bottom', '0');
            $('.long-statistic-text:last-child').css('margin-bottom', '-20%');
          }
        }
        else{
          $('.long-block-statistic').css('margin-bottom', '40px');
        }
      }
      
      function setHangingStatistic() {
     
        if(window.$window.width() > 750) {
          $('.long-statistic-text').css('margin-bottom', '-20%');
        }
        else{
          $('.long-statistic-text').css('margin-bottom', '0');
          $('.long-statistic-text:last-child').css('margin-bottom', '-20%');
        }
      }
      // Form comment extra class
      // -------
      $commentForm = $("#commentform");
      if($commentForm.length > 0) {
        $commentForm.addClass("form-wrapper form-wrapper-gray");
        $commentForm.find(".comment-form-author, .comment-form-email").addClass("field field-text");
        $commentForm.find(".comment-form-comment").addClass("field field-textarea field-required");
        $commentForm.find(".form-submit").addClass("field field-submit");
      }


      // Blog length indicator
      // -------
      var $singleIndicator = $(".single-navigation-sticky-indicator");
      if($singleIndicator.length > 0) {
        $blogPostContent = $(".blog-post-content");
        window.$window.on("scroll", handleSingleProgess);
      }


      // Subscribe button link
      // -------
      $(".blog-subscribe-button").on("click", handleBlogSubscriptionButton);
      $(".blog-introduction-form-close").on("click", handleCloseBlogSubscriptionForm);


      // Comment form confirmation message
      // -------
      $("#commentform").on("submit", blogFormCookieForConfirmationMessage);
      blogFormHandleConfirmationMessage();

      function buildQuiz(){
        // variable to store the HTML output
        var output = [];
    
        // for each questionQuiz...
        myQuestions.forEach(function
          (currentQuestion, questionNumber) {
    
            // variable to store the list of possible answersQuiz
            var answersQuiz = [];
    
            // and for each available answer...
            for(letter in currentQuestion.answersQuiz){
    
              // ...add an HTML radio button
              answersQuiz.push(
                '<label><input type="radio" name="questionQuiz'+questionNumber+'" value="'+letter+'">'+currentQuestion.answersQuiz[letter]+'</label>'
              );
            };
    
            // add this questionQuiz and its answersQuiz to the output
            output.push(
              '<div class="questionQuiz">'+currentQuestion.questionQuiz+'</div><div class="answersQuiz">'+ answersQuiz.join('')+'</div>'
            );
          }
        );
  
        // finally combine our output list into one string of HTML and put it on the page
        quizContainer.innerHTML = output.join('');
      }
      
      function showResults(){
        // gather answer containers from our quiz
        var answerContainers = document.querySelector('.answersQuiz');       
    
        // keep track of user's answersQuiz
        var numCorrect = 0;
    
        // for each questionQuiz...
        myQuestions.forEach(function (currentQuestion, questionNumber) {
    
          // find selected answer
          var answerContainer = answerContainers[questionNumber];
          var selector = 'input[name=questionQuiz'+questionNumber+']:checked';
          var userAnswer = (document.querySelector(selector) || {}).value;
    
          // if answer is correct
          if(userAnswer === currentQuestion.correctAnswer){
            // add to the number of correct answersQuiz
            numCorrect++;
    
            // color the answersQuiz green
            answerContainers.style.color = '#00ba4c';
    
            // show number of correct answersQuiz out of total // ${numCorrect} / ${myQuestions.length} 
            resultsContainer.innerHTML = "Bonne réponse, on voit que tu t'y connais!";
          }
          // if answer is wrong or blank
          else{
            // color the answersQuiz red
            answerContainers.style.color = 'red';
    
            // show number of correct answersQuiz out of total
            resultsContainer.innerHTML = "Plus encore! C'est 87% des processus d’achat de produits ou services qui commencent en ligne. ";
          }
        });
      }
    
      var quizContainer = document.getElementById('quiz');
      var resultsContainer = document.getElementById('results');
      var submitButton = document.getElementById('submit');
      var myQuestions = [
        {
          questionQuiz: "Quel pourcentage des processus d’achat de produits ou services commencent-ils en ligne selon vous?",
          answersQuiz: {
            a: "65%",
            b: "87%",
            c: "35%",
            d: "75%",
          },
          correctAnswer: "b"
        }
      ];
    
      // Kick things off
      if(document.getElementById("quiz")){
        buildQuiz();
      }
    
      // Event listeners
      if(document.getElementById('submit')){
        submitButton.addEventListener('click', showResults);
      }

    }
  }

  // Handle single reading progess
  //
  function handleSingleProgess(e) {
    var scroll_middle = window.$window.scrollTop() + (window.$window.height() / 6);
    var content_top = $blogPostContent.offset().top;
    var content_bottom = content_top + $blogPostContent.outerHeight();
    var content_height = content_bottom - content_top;

    var progess_percent = 0;
    if(scroll_middle <= content_top) {
      progess_percent = 0
    }else if(scroll_middle >= content_bottom) {
      progess_percent = 100
    }else{
      var scroll_height = scroll_middle - content_top;
      progess_percent = (scroll_height / content_height) * 100;
    }

    $(".single-navigation-sticky-indicator").css("width", progess_percent+"%");
  }


  // Blog subscriptions form
  // ---------------------------------------

  // Show subscription box
  //
  function handleBlogSubscriptionButton(e) {
    e.preventDefault();
    $(".blog-introduction-form").addClass("show");
  }


  // Hide subscription box
  //
  function handleCloseBlogSubscriptionForm(e) {
    e.preventDefault();
    $(".blog-introduction-form").removeClass("show");
  }



  // Blog comment form
  // ---------------------------------------

  // Create a cookie on form submit
  //
  function blogFormCookieForConfirmationMessage(e) {
    setCookie("leo_blog_comment_confirmation", 1, 1);
  }

  function blogFormHandleConfirmationMessage(e) {
    if(getCookie("leo_blog_comment_confirmation") == 1) {
      setCookie("leo_blog_comment_confirmation", 0, 1);
      $("#comments-alert").addClass("show");

      setTimeout(function() {
        $("#comments-alert").addClass("completed");
      }, 6000);
    }
  }


}

// Push class in bootstack
arrBootStack.push(Blog);
// This class handle «Candidature» et «Candidature Merci» component
//
var CandidatureMerci = new function() {
  var _self = this,
      $candidatureReponseCheck, $candidatureReponseRadio;

  this.initialize = function () {
    $candidatureReponseCheck = $(".candidature-merci-reponse.checkbox");
    $candidatureReponseRadio = $(".candidature-merci-reponse.radio");

    $candidatureReponseCheck.on('click', setCheckmark);
    $candidatureReponseRadio.on('click', setRadio);

    if($('.candidature-form').length > 0) {
      candidatureText();
    }
  }

  function setCheckmark() {
    if(!$(this).hasClass('other')) {
      $(this).toggleClass('checked');
      var checkBoxes = $(this).children('input');
      checkBoxes.prop("checked", !checkBoxes.prop("checked"));
    }
  }
  
  function setRadio() {
    $(this).addClass('checked');
    var radio = $(this).children("input[type='radio']");
    radio.prop("checked", true);

    var allRadios = $(".candidature-merci-reponse.radio input[type='radio']");
    allRadios.not(radio).each(function() {
      $(this).parent().removeClass("checked");
      $(this).prop("checked", false);
    });
  }

  function candidatureText() {
    if(window.job_title == "Expert en Marketing Numérique") {
      $('.presentation-modular .field-file-or-url-choices-label').html('Montre-nous le projet dont tu es le plus fier! (Facultative)');
    }
  }
}

// Push class in bootstack
arrBootStack.push(CandidatureMerci);
// This class handle «careers introduction» component
//
var CareersIntroduction = new function() {
//   var _self = this,
//       $careersIntroductions = [];

  this.initialize = function () {
    // $careersIntroductions = $(".custom-section.careers-introduction");

    // if($careersIntroductions.length > 0) {
    //   if(job_listing_open_count && job_listing_open_count > 0) {
    //     var $button = $careersIntroductions.find(".careers-introduction-step-2 .button");
    //     $button.text(sprintf($button.data("text-with-count"), job_listing_open_count));
    //   }


    //   autoScalingTitle();
    //   window.$window.on("scroll", setActiveState);

    //   setTimeout(function() {
    //     $("html").scrollTop(0);
    //     window.$window.scrollTop(0);
    //     autoScalingTitle();
    //   }, 1300);

    //   setHeight();

    //   // Block scroll during animation
    //   $("html").addClass("careers-page scroll-block");
    //   setTimeout(function() {
    //     $("html").removeClass("scroll-block");
    //     window.$body.addClass("careers-page-animation-done");
    //     window.$window.on("resize", autoScalingTitle);
    //     autoScalingTitle();
    //   }, 7050);


    //   // Animation for max-height in javascript for introduction content
    //   setTimeout(function() {
    //     var $description = $careersIntroductions.find(".careers-introduction-step-2-description");
    //     var max_height = find_hidden_height($description);
    //     $description.css("max-height", max_height+"px");
    //   }, 5050);
    // }
  }


  // Set height of the career introduction content
  //
//   function setHeight() {
//     var slideshow_heigth = window.$window.height() - 6;
//     var content_height = find_hidden_height($careersIntroductions.find(".careers-introduction-step-2 .inner-content .careers-introduction-step-2-description")) + $careersIntroductions.find(".careers-introduction-step-2 .inner-content h1").outerHeight() + $(".leonard-main-navigation-wrapper").outerHeight() + 70;

//     if(content_height > slideshow_heigth) {
//       slideshow_heigth = content_height;
//     }

//     $careersIntroductions.find(".careers-introduction-step-2").css({
//       minHeight: slideshow_heigth,
//       marginTop: "-"+$(".leonard-meta-nav").outerHeight()+"px",
//     });
//   }


  // Auto title resize based on parent width
  //
//   function autoScalingTitle() {
//     var $h1 = $careersIntroductions.find("h1");
//     var $spans = $h1.find("span");
//     var max_width = $careersIntroductions.find(".inner-content").width();
//     var allowed_width_span = max_width / $spans.length;

//     // Guest font-size to fix window width
//     $h1.css("font-size", "inherit");
//     for(var i=1; max_width > $h1.width(); i++) {
//       $h1.css({
//         fontSize: (allowed_width_span + i),
//         lineHeight: (allowed_width_span + i) + "px",
//       });
//     }


//     // Validate that all span are at the same height
//     for(var ii=1; autoScalingTitleSpanSameHeight($spans) == false; ii++) {
//       $h1.css({
//         fontSize: (allowed_width_span + i - ii),
//         lineHeight: (allowed_width_span + i - ii) + "px",
//       });

//       if(ii >= 100) {
//         // Prevent infinite loop
//         break;
//       }
//     }
//   }

  // Check if span are at the same offset top
  //
  // @return Boolean
//   function autoScalingTitleSpanSameHeight($spans) {
//     var span_same_height = true;
//     var span_latest_height = $spans.eq(0).offset().top;
//     $spans.each(function() {
//       if(span_latest_height != $(this).offset().top) {
//         span_same_height = false;
//       }
//     });

//     return span_same_height;
//   }


  // Set sticky navigation active state based on scroll position
  function setActiveState(e) {
    var scroll_top = window.$window.scrollTop() + 120;
    var $links = $(".careers-introduction-navigation-sticky .inner-content > ul > li:not(.share) > a");
    var $last_link;

    // Find lowest link in the page
    $links.each(function() {
      var $link = $(this);
      var $target = $($(this).attr("href"));

      if($target.offset().top < scroll_top) {
        $last_link = $link;
      }
    });


    // Set class
    $links.removeClass("current");
    if($last_link) {
      $last_link.addClass("current");
    }
  }

}

// Push class in bootstack
// arrBootStack.push(CareersIntroduction);
// This class handle «careers news» component
//
var CareersNews = new function() {
  var _self = this,
      $careersNews = [];

  this.initialize = function () {
    $careersNews = $(".custom-section.careers-news");

    if($careersNews.length > 0) {
      $careersNews.find(".row").each(function() {
        var $divs = $(this).find("> div:not(.gr-24)");
        sameHeight($divs, 9999, 1300, "outerHeight");


        var $events = $(this).find(".events-listing-item");
        sameHeight($events, 1300, 900, "outerHeight");
      });
    }
  }

}

// Push class in bootstack
arrBootStack.push(CareersNews);
// This class handle «case studies big» component
//
var CaseStudiesBig = new function() {
  var _self = this,
      $caseStudies;

  this.initialize = function () {
    $caseStudies = $(".custom-section.case-studies-big");

    if($caseStudies.length > 0) {
      window.$window.on("scroll", handleCaseStudiesVisiblity);
    }
  }


  // Handle caseStudies visibility on scroll
  //
  function handleCaseStudiesVisiblity(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height() - (window.$window.height() / 5);

    $caseStudies.filter(":not(.visible)").each(function() {
      var $caseStudy = $(this);
      if($caseStudy.offset().top < scroll_bottom) {
        $caseStudy.addClass("visible");
      }
    });
  }


}

// Push class in bootstack
arrBootStack.push(CaseStudiesBig);
document.addEventListener('DOMContentLoaded', function () {
    var filterSelect = document.getElementById('case-study-filter');
    var caseStudiesList = document.getElementById('case-studies-list');
    var caseStudies = caseStudiesList.querySelectorAll('.case-studies-full-listing-column-wrapper');
  
    filterSelect.addEventListener('change', function () {
      var selectedType = this.value;
  
      for (var i = 0; i < caseStudies.length; i++) {
        var caseStudy = caseStudies[i];
        if (selectedType === 'all' || caseStudy.getAttribute('data-type') === selectedType) {
          caseStudy.style.display = 'block';
        } else {
          caseStudy.style.display = 'none';
        }
      }
    });
  });  
// This class handle case studies slideshow component
//
var CaseStudiesSlideshow = new function() {
  var _self = this,
      slide_transition_length = 800,
      can_switch_slides = true; // @todo, support by slider

  this.initialize = function () {
    if($(".case-studies-slideshow").length > 0) {
      $slides = $(".case-studies-slideshow-slides");

      $slides.on("click", ".case-studies-slideshow-slides-prev, .case-studies-slideshow-slides-next", handlePagination);

      $slides.on("click", ".case-studies-slideshow-slides-slide.current", redirectToChildrenLink);

      $slides.on("mouseenter", ".case-studies-slideshow-slides-slide.next", handleMouseEnterOnNextSlide)
             .on("mouseleave", ".case-studies-slideshow-slides-slide.next", handleMouseLeaveNextSlide)
             .on("click", ".case-studies-slideshow-slides-slide.next", handleClickOnNextSlide);


      // Set cards the sameheight
      window.$slides.each(function() {
        var $slide = $(this);

        var $sub_slides = $slide.find(".case-studies-slideshow-slides-slide-content");
        sameHeight($slide.find(".case-studies-slideshow-slides-slide h3"), 9999, 0, "height");
        sameHeight($sub_slides, 9999, 0, "outerHeight");

        // Set first slide and content the same height has slides
        var slide_height = $sub_slides.eq(1).outerHeight();
        $slide.css("min-height", slide_height);
        $slide.find(".current").css("min-height", slide_height);

        if(window.$window.width() > 1024) {
          $slide.parent().find(".case-studies-slideshow-content").css("min-height", slide_height);
        }
      });
    }
  }


  function handlePagination(e) {
    e.preventDefault();

    var $el = $(e.currentTarget);
    var $parent = findParent($el);


    if(can_switch_slides) {
      can_switch_slides = false;

      // This where we handle the infinite loop
      if($el.hasClass("case-studies-slideshow-slides-next")) {
        // Next
        // 1) We clone the current element into the backlog
        var $clone = $parent.find(".past").clone();
        $clone.removeClass("past").addClass("backlog");
        $clone.appendTo($parent.find(".case-studies-slideshow-slides-inventory"));

        // 2) We delete the slide set has past
        $parent.find(".past").remove();

        // 3) We toggle classes to do the animation
        $parent.find(".current").removeClass("current").addClass("past");
        $parent.find(".next").removeClass("next").addClass("current");
        $parent.find(".next-cut").removeClass("next-cut").addClass("next");
        $parent.find(".backlog").first().removeClass("backlog").addClass("next-cut");
      }else if($el.hasClass("case-studies-slideshow-slides-prev")){
        // Previous
        var $last_backlog = $parent.find(".backlog").last();

        // 1) We find the last element in the backlog and clone has past
        var $clone = $last_backlog.clone();
        $clone.removeClass("backlog").addClass("past");
        $clone.prependTo($parent.find(".case-studies-slideshow-slides-inventory"));

        // 2) We delete the last element in the backlog
        $parent.find(".backlog").last().remove();

        // 3) We toggle class to do the animation
        $parent.find(".next-cut").removeClass("next-cut").addClass("backlog");
        $parent.find(".next").removeClass("next").addClass("next-cut");
        $parent.find(".current").removeClass("current").addClass("next");
        $parent.find(".past").last().removeClass("past").addClass("current");
      }

      setTimeout(function() {
        can_switch_slides = true;
      }, slide_transition_length);
    }
  }


  // Handle hover on next slide to show next button has active
  //
  function handleMouseEnterOnNextSlide(e) {
    var $el = $(e.currentTarget);
    var $parent = findParent($el);

    $parent.find(".case-studies-slideshow-slides-next").addClass("active");
  }


  // Handle blur on next slide to show next button has inactive
  //
  function handleMouseLeaveNextSlide(e) {
    var $el = $(e.currentTarget);
    var $parent = findParent($el);

    $parent.find(".case-studies-slideshow-slides-next").removeClass("active");
  }


  // Handle click on next slide
  //
  function handleClickOnNextSlide(e) {
    e.preventDefault();

    var $el = $(e.currentTarget);
    var $parent = findParent($el);

    $parent.find(".case-studies-slideshow-slides-next").trigger("click")
                                                       .removeClass("active");
  }


  function findParent($el) {
    return $el.parents(".case-studies-slideshow-slides");;
  }

}

// Push class in bootstack
arrBootStack.push(CaseStudiesSlideshow);

document.addEventListener('DOMContentLoaded', function () {
    if ($('.leonard-clients-swiper').length) {
        leonardClientsSlider();
    }

    function leonardClientsSlider() {
        swiper = new Swiper('.leonard-clients-swiper', {
            spaceBetween: 40,
            speed: 3000,
            loop: true,
            autoplay: {
                delay: 0,
            },
            slidesPerView: 1,
            breakpoints: {
                600: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 5.5,
                },
            },
        });
    }
    
});
// This class handle «culture values testimonials» component
//
var CultureValuesTestimonials = new function() {
  var _self = this,
      $cultureValuesTestimonials = [];

  this.initialize = function () {
    $cultureValuesTestimonials = $(".custom-section.culture-values-testimonials");

    if($cultureValuesTestimonials.length > 0) {
      $cultureValuesTestimonials.find(".culture-values-testimonials-cultures-values-slick").slick({
        slidesToShow: 1,
        fade: true
      }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        // @todo support multiple slide
        $(".culture-values-testimonials-cultures-values-pagination-current").text((nextSlide + 1));
      });


      // Show random testimonial
      $cultureValuesTestimonials.find(".culture-values-testimonials-cultures-values-value").each(function() {
        var $testimonials = $(this).find(".culture-values-testimonials-cultures-values-value-testimonial");
        if($testimonials.length > 1) {
          var random_int = getRandomInt(0, ($testimonials.length-1));
          $testimonials.eq(random_int).removeClass("hide");
        }else{
          $testimonials.eq(0).removeClass("hide");
        }
      })

    }
  }
}

// Push class in bootstack
arrBootStack.push(CultureValuesTestimonials);
// This class handle «dark circle slider» component
//
var DarkCircleSliderFull = new function() {
  var _self = this,
      $darkCircleSliders = [],
      arrTimeout = [],
      arrInterval = [],
      timerInterval = 500,
      timerDotsCount = 12;
      stopInProgressDots = false;
        
  function hideShowCurrentNextPreviousLink(number) {
    var $nextCurrentLink =  document.querySelectorAll(".dark-circle-slider-full-slides-slide.current .step-next");
    var $previousCurrentLink =   document.querySelectorAll(".dark-circle-slider-full-slides-slide.current .step-previous");

    switch (number) {
      case 0: //showCurrentNextPreviousLink
        $($previousCurrentLink).addClass("show");
        $($previousCurrentLink).removeClass("hide");
        $($nextCurrentLink).addClass("show");
        $($nextCurrentLink).removeClass("hide");
        hideNotShowNextPreviousLink();
          break;
      case 1: //showCurrentNextLink
        $($nextCurrentLink).addClass("show");
        $($nextCurrentLink).removeClass("hide");
        hideNotShowNextPreviousLink();
          break;
      case 2: //showCurrentPreviousLink
        $($previousCurrentLink).addClass("show");
        $($previousCurrentLink).removeClass("hide");
        hideNotShowNextPreviousLink();
          break;
      case 3: //hideCurrentNextLink
        $($nextCurrentLink).addClass("hide");
        $($nextCurrentLink).removeClass("show");
        hideNotShowNextPreviousLink();
          break;
      case 4: //hideCurrentPreviousLink
        $($previousCurrentLink).addClass("hide");
        $($previousCurrentLink).removeClass("show");
        hideNotShowNextPreviousLink();
          break;
    }
  }

  function hideNotShowNextPreviousLink() {
    var $nextLinkNotShow =  document.querySelectorAll(".dark-circle-slider-full-slides-slide:not(.current) .step-next");
    var $previousLinkNotShow =   document.querySelectorAll(".dark-circle-slider-full-slides-slide:not(.current) .step-previous");

    $($nextLinkNotShow).addClass("hide");
    $($nextLinkNotShow).removeClass("show");
    $($previousLinkNotShow).addClass("hide");
    $($previousLinkNotShow).removeClass("show");
  }

  this.initialize = function () {
    $darkCircleSliders = $(".custom-section.dark-circle-slider-full");
    hideShowCurrentNextPreviousLink(1);
    if($darkCircleSliders.length > 0) {

      if(window.$window.width() > 750) {
        // Desktop
        $darkCircleSliders.on("click", ".dark-circle-slider-full-circles-pagination-item", handlePaginationClick);
        $darkCircleSliders.on("click", ".step-next p", handleStepNextClick);
        $darkCircleSliders.on("click", ".step-previous p", handleStepPreviousClick);

        $darkCircleSliders.on("mouseover", ".dark-circle-slider-full-circles-pagination-item", handlePaginationMouseOver)
                          .on("mouseleave", ".dark-circle-slider-full-circles-pagination-item", handleSlideMouseLeave);

        window.$window.on("resize", setMinHeightOfCircle);
        window.$window.on("scroll", handleSliderVisibility);
      }else{
        // Mobile
        window.$window.on("scroll", handleStepVisibility);
      }
    }
  }

  // Handle interval to show time remaining before next slide
  //
  function handleInterval($darkCircle) {
    var $past_dots = $darkCircle.find(".dark-circle-slider-full-circles-seconds .past");

    if(($past_dots.length / timerDotsCount) == ($darkCircle.data("index") + 1)) {
      var next_index = $darkCircle.data("index") + 1;
      // Infinite Loop
      // if(next_index >= max_index) {
      //   next_index = 0;
      // }

      switchToIndex($darkCircle, next_index);
    }else{
      // In progress
      if(stopInProgressDots != true) {
        if($darkCircle.find(".dark-circle-slider-full-circles-seconds .past").length == 0) {
          $darkCircle.find(".dark-circle-slider-full-circles-seconds b").first().addClass("past");
        }else{
          $darkCircle.find(".dark-circle-slider-full-circles-seconds .past").next().addClass("past");
        }
      }
    }
  }


  // Handle pagination click
  //
  function handlePaginationClick(e) {
    e.preventDefault();

    var $el = $(e.currentTarget);
    var $darkCircle = $el.parents(".custom-section.dark-circle-slider-full");
    var $fakeHover = $darkCircle.find(".dark-circle-slider-full-circles-circle-slide-fake-hover");

    $fakeHover.removeClass("hover");
    switchToIndex($darkCircle, $el.parent().find($el).index());
    clearInterval(arrInterval[$darkCircle.data("parent-index")]);

    switch ($el.index()) {
      case 0:
        hideShowCurrentNextPreviousLink(1);
          break;
      case 1:
        hideShowCurrentNextPreviousLink(0);
          break;
      case 2:
        hideShowCurrentNextPreviousLink(0);
          break;
      case 3:
        hideShowCurrentNextPreviousLink(2);
          break;
    }
  }  
  
  // Handle pagination click
  //
  function handleStepNextClick() {
    stopInProgressDots = true;
    var $inProgressDots =  document.getElementsByClassName("dark-circle-slider-full-circles-seconds-b");
    var $darkCircleCurrent = document.getElementsByClassName("dark-circle-slider-full-circles-pagination-item current");
    var $darkCirclePast = document.getElementsByClassName("dark-circle-slider-full-circles-pagination-item past");
    var $darkCircleNextCurrent = document.querySelectorAll('.dark-circle-slider-full-circles-pagination-item:not(.past,.current)')[0];
    var $darkCircleSlider = document.getElementsByClassName("dark-circle-slider-full-slides-slide");
    var $darkCircleSliderCurrent = document.getElementsByClassName("dark-circle-slider-full-slides-slide current");

    if($darkCircleNextCurrent != null) {
      if($darkCircleNextCurrent.length != 0) {
        $($darkCircleCurrent).addClass("past");
        $($darkCircleCurrent).removeClass('current');
        $($darkCircleNextCurrent).addClass("current");
      }
    }

    switch ($darkCirclePast.length) {
      case 1:
        $($darkCircleSliderCurrent).removeClass('current');
        $($darkCircleSlider[1]).addClass("current");
        hideShowCurrentNextPreviousLink(0);
        for (var i = 0; i < 12; i++) {
          $($inProgressDots[i]).addClass("past");
        }
          break;
      case 2:
        $($darkCircleSliderCurrent).removeClass('current');
        $($darkCircleSlider[2]).addClass("current");
        for (var i = 12; i < 24; i++) {
          $($inProgressDots[i]).addClass("past");
        }
        hideShowCurrentNextPreviousLink(0);
          break;
      case 3:
        $($darkCircleSliderCurrent).removeClass('current');
        $($darkCircleSlider[3]).addClass("current");
        for (var i = 24; i < 36; i++) {
          $($inProgressDots[i]).addClass("past");
        }
        hideShowCurrentNextPreviousLink(2);
        hideShowCurrentNextPreviousLink(3);
          break;
    }
  }

  // Handle pagination click
  //
  function handleStepPreviousClick() {
    stopInProgressDots = true;
    var $darkCircleCurrent = document.getElementsByClassName("dark-circle-slider-full-circles-pagination-item current");
    var $darkCirclePast = document.querySelectorAll(".dark-circle-slider-full-circles-pagination-item.past");
    var $darkCircleLastPast = $darkCirclePast.length -1;
    var $darkCirclePreviousCurrent = document.getElementsByClassName("dark-circle-slider-full-circles-pagination-item past")[$darkCircleLastPast];
    var $inProgressDots =  document.getElementsByClassName("dark-circle-slider-full-circles-seconds-b");
    var $darkCircleSlider = document.getElementsByClassName("dark-circle-slider-full-slides-slide");
    var $darkCircleSliderCurrent = document.getElementsByClassName("dark-circle-slider-full-slides-slide current");

    if($darkCirclePreviousCurrent != null) {
      if($darkCirclePreviousCurrent.length != 0) {
        $($darkCircleCurrent).removeClass('current');
        $($darkCirclePreviousCurrent).removeClass("past");
        $($darkCirclePreviousCurrent).addClass("current");
      }
    }

    switch ($darkCirclePast.length) {
      case 0:
        hideShowCurrentNextPreviousLink(1);
          break;
      case 1:
        $($darkCircleSliderCurrent).removeClass('current');
        $($darkCircleSlider[0]).addClass("current");
        hideShowCurrentNextPreviousLink(1);
        hideShowCurrentNextPreviousLink(4);
        for (var i = 0; i < 12; i++) {
          $($inProgressDots[i]).removeClass("past");
        }
          break;
      case 2:
        $($darkCircleSliderCurrent).removeClass('current');
        $($darkCircleSlider[1]).addClass("current");
        hideShowCurrentNextPreviousLink(0);
        for (var i = 12; i < 24; i++) {
          $($inProgressDots[i]).removeClass("past");
        }
          break;
      case 3:
        $($darkCircleSliderCurrent).removeClass('current');
        $($darkCircleSlider[2]).addClass("current");
        hideShowCurrentNextPreviousLink(0);
        for (var i = 24; i < 36; i++) {
          $($inProgressDots[i]).removeClass("past");
        }
          break;
    }
  }

  // Handle pagination item mouse hover to show preview of slide
  //
  function handlePaginationMouseOver(e) {
    var $el = $(e.currentTarget);
    var index = $el.parent().find($el).index();
    var $slide = $el.parents(".dark-circle-slider-full-circles").find(".dark-circle-slider-full-circles-circle-slide").eq(index);
    var $fakeHover = $el.parents(".dark-circle-slider-full-circles").find(".dark-circle-slider-full-circles-circle-slide-fake-hover");


    if(!$slide.hasClass("current")) {
      $slide.addClass("hover");
      $fakeHover.find(".content").html("<h3>"+$slide.find("h3").html()+"</h3>");
      $fakeHover.addClass("hover");
    }else{
      $slide.removeClass("hover");
      $fakeHover.removeClass("hover")
    }
  }


  // Handle pagination item mouse lead to hiden previw of slide
  //
  function handleSlideMouseLeave(e) {
    var $el = $(e.currentTarget);
    var index = $el.parent().find($el).index();
    var $slide = $el.parents(".dark-circle-slider-full-circles").find(".dark-circle-slider-full-circles-circle-slide").eq(index);
    var $fakeHover = $el.parents(".dark-circle-slider-full-circles").find(".dark-circle-slider-full-circles-circle-slide-fake-hover");

    $slide.removeClass("hover");
    $fakeHover.removeClass("hover");
  }


  // Switch everything to a new index
  //
  function switchToIndex($darkCircle, new_index) {
    // Clear interval
    clearInterval(arrInterval[$darkCircle.data("parent-index")]);
    var $darkCirclePast = document.getElementsByClassName("dark-circle-slider-full-circles-pagination-item past");

    // Set parent slide index
    $darkCircle.data("index", new_index);

    // Pagination items
    $darkCircle.find(".dark-circle-slider-full-circles-pagination-item").removeClass("current past");
    $darkCircle.find(".dark-circle-slider-full-circles-pagination-item").eq(new_index).addClass("current");
    paginationSetPreviousStepHasPast($darkCircle.find(".dark-circle-slider-full-circles-pagination-item").eq(new_index));

    // Timer dots
    $darkCircle.find(".dark-circle-slider-full-circles-seconds b").slice(0, (new_index*timerDotsCount)).addClass("past");
    $darkCircle.find(".dark-circle-slider-full-circles-seconds b").slice((new_index*timerDotsCount), $darkCircle.find(".dark-circle-slider-full-circles-seconds b").length).removeClass("past");

    // Slides
    $darkCircle.find(".dark-circle-slider-full-slides-slide").removeClass("current");
    $darkCircle.find(".dark-circle-slider-full-slides-slide").eq(new_index).addClass("current");


    // Restart interval
    var max_index = $darkCircle.find(".dark-circle-slider-full-circles-pagination-item").length - 1;
    if(max_index == new_index) {
      clearInterval(arrInterval[$darkCircle.data("parent-index")]);
    }else{
      arrInterval[$darkCircle.data("parent-index")] = setInterval(handleInterval, timerInterval, $darkCircle);
    }

    switch ($darkCirclePast.length) {
      case 1:
        hideShowCurrentNextPreviousLink(0);
          break;
      case 2:
        hideShowCurrentNextPreviousLink(0);
          break;
      case 3:
        hideShowCurrentNextPreviousLink(2);
        hideShowCurrentNextPreviousLink(3);
          break;
    }
  }


  // Set pagination previous step has past
  //
  function paginationSetPreviousStepHasPast($current_pagination_item) {
    for(var i = 0; $current_pagination_item.prev().length != 0; i++) {
      $current_pagination_item.prev().addClass("past");
      $current_pagination_item = $current_pagination_item.prev();
      if(i >= 10) {
        break;
      }
    }
  }


  // Set minimum height for dark circle full
  //
  function setMinHeightOfCircle() {
    $darkCircleSliders.each(function() {
      var $darkCircleSlider = $(this);
      if(window.$window.width() > 950) {
        var minHeight = 600;
      }else {
        var minHeight = 0;
      }

      $darkCircleSlider.find(".dark-circle-slider-full-slides-slide").each(function() {
        var element_height = find_hidden_height($(this));
        if(minHeight < element_height) {
          minHeight = element_height;
        }
      });

      $darkCircleSlider.css("min-height", minHeight);
    });
  }


  // When the slider is in the middle of the screen we start the interval
  //
  function handleSliderVisibility(e) {
    $darkCircleSliders.each(function(index, value) {
      var $el = $(this);
      var window_bottom = window.$window.scrollTop() + (window.$window.height() / 2);

      if($el.offset().top < window_bottom && $el.data("parent-index") == undefined) {
        $el.data("parent-index", index);
        arrInterval.push(setInterval(handleInterval, timerInterval, $el));
      }
    });
  }


  // Check if the step is visible when we scroll in the page on mobile
  //
  function handleStepVisibility(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height();

    // Every 2px
    if(scroll_bottom % 2 == 0) {
      $darkCircleSliders.each(function() {
        var $dark_circle = $(this);
        var $titles = $dark_circle.find(".dark-circle-slider-full-slides-slide h2");
        var $last_selected_title = $titles.eq(0);

        // Find lowest title
        $titles.each(function() {
          var $title = $(this);
          var title_bottom_position = $title.offset().top + $title.outerHeight() + 20;

          if(title_bottom_position < scroll_bottom) {
            $last_selected_title = $title;
          }
        });

        // Set class
        var $parent = $last_selected_title.parents(".dark-circle-slider-full-slides-slide");
        if(!$parent.hasClass("current-mobile")) {
          $dark_circle.find(".dark-circle-slider-full-slides-slide").removeClass("current-mobile");
          $parent.addClass("current-mobile");
        }
      });
    }
  }

}

// Push class in bootstack
arrBootStack.push(DarkCircleSliderFull);
// This class handle «dark circle slider» component
//
var DarkCircleSlider = new function() {
  var _self = this,
      $darkCircleSliders = [],
      arrTimeout = [],
      arrInterval = [],
      timerInterval = 700;

  this.initialize = function () {
    $darkCircleSliders = $(".custom-section.dark-circle-slider");
    if($darkCircleSliders.length > 0) {

      if(window.$window.width() > 550) {
        // Desktop
        $darkCircleSliders.on("click", ".dark-circle-slider-circles-pagination-item", handlePaginationClick);

        $darkCircleSliders.on("mouseover", ".dark-circle-slider-circles-pagination-item", handlePaginationMouseOver)
                          .on("mouseleave", ".dark-circle-slider-circles-pagination-item", handleSlideMouseLeave);

        window.$window.on("scroll", handleSliderVisibility);
      }else{
        // Mobile
        window.$window.on("scroll", handleStepVisibility);
      }
    }
  }

  // Handle interval to show time remaining before next slide
  //
  function handleInterval($darkCircle) {
    var $past_dots = $darkCircle.find(".dark-circle-slider-circles-seconds .past");

    if(($past_dots.length / timerDotsCount()) == ($darkCircle.data("index") + 1)) {
      var next_index = $darkCircle.data("index") + 1;
      // Infinite Loop
      // if(next_index >= max_index) {
      //   next_index = 0;
      // }

      switchToIndex($darkCircle, next_index);
    }else{
      // In progress
      if($darkCircle.find(".dark-circle-slider-circles-seconds .past").length == 0) {
        $darkCircle.find(".dark-circle-slider-circles-seconds b").first().addClass("past");
      }else{
        $darkCircle.find(".dark-circle-slider-circles-seconds .past").next().addClass("past");
      }
    }
  }


  // Handle pagination click
  //
  function handlePaginationClick(e) {
    e.preventDefault();

    var $el = $(e.currentTarget);
    var $darkCircle = $el.parents(".custom-section.dark-circle-slider");
    var $fakeHover = $darkCircle.find(".dark-circle-slider-circles-circle-slide-fake-hover");

    $fakeHover.removeClass("hover");
    switchToIndex($darkCircle, $el.parent().find($el).index());
    clearInterval(arrInterval[$darkCircle.data("parent-index")]);
  }


  // Handle pagination item mouse hover to show preview of slide
  //
  function handlePaginationMouseOver(e) {
    var $el = $(e.currentTarget);
    var index = $el.parent().find($el).index();
    var $slide = $el.parents(".dark-circle-slider-circles").find(".dark-circle-slider-circles-circle-slide").eq(index);
    var $fakeHover = $el.parents(".dark-circle-slider-circles").find(".dark-circle-slider-circles-circle-slide-fake-hover");


    if(!$slide.hasClass("current")) {
      $slide.addClass("hover");
      $fakeHover.find(".content").html("<h3>"+$slide.find("h3").html()+"</h3>");
      $fakeHover.addClass("hover");
    }else{
      $slide.removeClass("hover");
      $fakeHover.removeClass("hover")
    }
  }


  // Handle pagination item mouse lead to hiden previw of slide
  //
  function handleSlideMouseLeave(e) {
    var $el = $(e.currentTarget);
    var index = $el.parent().find($el).index();
    var $slide = $el.parents(".dark-circle-slider-circles").find(".dark-circle-slider-circles-circle-slide").eq(index);
    var $fakeHover = $el.parents(".dark-circle-slider-circles").find(".dark-circle-slider-circles-circle-slide-fake-hover");

    $slide.removeClass("hover");
    $fakeHover.removeClass("hover");
  }


  // Switch everything to a new index
  //
  function switchToIndex($darkCircle, new_index) {
    // Clear interval
    clearInterval(arrInterval[$darkCircle.data("parent-index")]);

    // Set parent slide index
    $darkCircle.data("index", new_index);

    // Pagination items
    $darkCircle.find(".dark-circle-slider-circles-pagination-item").removeClass("current past");
    $darkCircle.find(".dark-circle-slider-circles-pagination-item").eq(new_index).addClass("current");
    paginationSetPreviousStepHasPast($darkCircle.find(".dark-circle-slider-circles-pagination-item").eq(new_index));


    // Timer dots
    $darkCircle.find(".dark-circle-slider-circles-seconds b").slice(0, (new_index*timerDotsCount())).addClass("past");
    $darkCircle.find(".dark-circle-slider-circles-seconds b").slice((new_index*timerDotsCount()), $darkCircle.find(".dark-circle-slider-circles-seconds b").length).removeClass("past");

    // Slides
    $darkCircle.find(".dark-circle-slider-circles-circle-slide").removeClass("current");
    $darkCircle.find(".dark-circle-slider-circles-circle-slide").eq(new_index).addClass("current");


    // Restart interval
    var max_index = $darkCircle.find(".dark-circle-slider-circles-pagination-item").length - 1;
    if(max_index == new_index) {
      clearInterval(arrInterval[$darkCircle.data("parent-index")]);
    }else{
      arrInterval[$darkCircle.data("parent-index")] = setInterval(handleInterval, timerInterval, $darkCircle);
    }
  }


  // Set pagination previous step has past
  //
  function paginationSetPreviousStepHasPast($current_pagination_item) {
    for(var i = 0; $current_pagination_item.prev().length != 0; i++) {
      $current_pagination_item.prev().addClass("past");
      $current_pagination_item = $current_pagination_item.prev();

      if(i >= 10) {
        console.log("infinite loop detected");
        break;
      }
    }
  }


  // When the slider is in the middle of the screen we start the interval
  //
  function handleSliderVisibility(e) {
    $darkCircleSliders.each(function(index, value) {
      var $el = $(this);
      var window_bottom = window.$window.scrollTop() + (window.$window.height() / 2);

      if($el.offset().top < window_bottom && $el.data("parent-index") == undefined) {
        $el.data("parent-index", index);
        arrInterval.push(setInterval(handleInterval, timerInterval, $el));
      }
    });
  }


  // Check if the step is visible when we scroll in the page on mobile
  //
  function handleStepVisibility(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height();

    // Every 2px
    if(scroll_bottom % 2 == 0) {
      $darkCircleSliders.each(function() {
        var $dark_circle = $(this);
        var $titles = $dark_circle.find(".dark-circle-slider-circles h3");
        var $last_selected_title = $titles.eq(0);

        // Find lowest title
        $dark_circle.find(".dark-circle-slider-circles h3").each(function() {
          var $title = $(this);
          var title_bottom_position = $title.offset().top + $title.outerHeight() + 20;

          if(title_bottom_position < scroll_bottom) {
            $last_selected_title = $title;
          }
        });

        // Set class
        var $parent = $last_selected_title.parents(".dark-circle-slider-circles-circle-slide");
        if(!$parent.hasClass("current-mobile")) {
          $dark_circle.find(".dark-circle-slider-circles-circle-slide").removeClass("current-mobile");
          $parent.addClass("current-mobile");
        }
      });
    }
  }


  // Return the number of dots between each step
  //
  function timerDotsCount() {
    if(window.$window.width() > 750) {
      return 12;
    }else{
      return 6;
    }
  }
}

// Push class in bootstack
arrBootStack.push(DarkCircleSlider);
// This class handle «dark stories» component
//
var DarkStories = new function() {
  var _self = this,
      $darkStories = [];

  this.initialize = function () {
    $darkStories = $(".custom-section.dark-stories");

    if($darkStories.length > 0) {
      $(".dark-stories-steps .row").each(function() {
        sameHeight($(this).find("> div:not(.gr-16)"), 9999, 900, "height");
      });

      window.$window.on("scroll", handleStoriesVisiblity);
    }
  }


  function handleStoriesVisiblity() {
    $(".dark-stories-steps-step").filter(":not(.visible)").each(function() {
      var scroll_bottom = window.$window.scrollTop() + window.$window.height() - (window.$window.height() / 5);

      var $story = $(this);
      if($story.offset().top < scroll_bottom) {
        $story.addClass("visible");
      }
    });
  }


}

// Push class in bootstack
arrBootStack.push(DarkStories);
// This class handle «expertise-conclusion» component
//
var ExpertiseConclusion = new function() {
  var _self = this,
      $expertiseConclusions;

  this.initialize = function () {
    $expertiseConclusions = $(".custom-section.expertise-conclusion");

    if($expertiseConclusions.length > 0) {
      window.$window.on("scroll", handleExpertiseConclusionsVisiblity);
    }
  }


  // Handle blocks visibility on scroll
  //
  function handleExpertiseConclusionsVisiblity(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height() - (window.$window.height() / 10);

    $expertiseConclusions.filter(":not(.visible)").each(function() {
      var $expertiseConclusion = $(this);
      var $expertiseConclusionExpertises = $expertiseConclusion.find(".expertise-conclusion-expertises");

      if($expertiseConclusionExpertises.length > 0) {
        if($expertiseConclusionExpertises.offset().top < scroll_bottom) {
          $expertiseConclusion.addClass("visible");
        }
      }
    });
  }


}

// Push class in bootstack
arrBootStack.push(ExpertiseConclusion);
// This class handle «expertise intro» component
//
var ExpertiseIntro = new function() {
  var _self = this,
      $expertiseIntros = [],
      animated = false;

  this.initialize = function () {
    $expertiseIntros = $(".custom-section.expertise-intro");

    if ($expertiseIntros.length > 0) {
        sameHeight($expertiseIntros.find(".left-content, .right-content"), 9999, 1024, "outerHeight");

      // Trigger animation when the section is visible
      $window.on("scroll", function () {
        if (!animated && isVisible($expertiseIntros)) {
          animated = true;
          animateNumbers($expertiseIntros.find(".animated-number"));
        }
      });
    }
  };

  // Check if an element is visible in the viewport
  function isVisible($el) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;

    // Check if the element is partially visible
    return rect.top < windowHeight && rect.bottom > 0;
  }

  // Animate numbers
  function animateNumbers($numbers) {
    $numbers.each(function () {
      var $this = $(this);
      var targetNumber = parseInt($this.data("number"), 10) || 0;

      $({ count: 0 }).animate({ count: targetNumber }, {
        duration: 2000, // Animation duration in milliseconds
        easing: "swing",
        step: function (now) {
          $this.text(Math.floor(now));
        },
        complete: function () {
          $this.text(targetNumber); // Ensure the final value is set
        }
      });
    });
  }
};

// Push class in bootstack
arrBootStack.push(ExpertiseIntro);
 // This class handle «form» component
//
var Form = new function() {
  var _self = this,
      $search;

  this.initialize = function () {
    assignEmailFromUrl_init();
    textAreaAutoresize_init();

    $("form .field").on("focus", "input[type=text], input[type=email], input[type=tel], select, textarea", setFocusClass);
    $("form .field").on("blur", "input[type=text], input[type=email], input[type=tel], select, textarea", removeFocusClass);

    $("form .field").on("keyup", "input[type=text], input[type=email], input[type=tel], textarea", setFilledClass)
                    .on("change", "select", setFilledClass);

    $("form .field-radio .wpcf7-list-item-label, form .field-checkbox .wpcf7-list-item-label").on("click", setRadioCheckedFromFakeLabel);

    $("form .field-file-or-url-choices .field-file-or-url-choices-options span").on("click", setFieldOrFile);
    $("form .field-file-or-url-choices .field-file-or-url-choices-cancel").on("click", cancelActionFieldOrFile);

    document.addEventListener('wpcf7mailsent', contactFormRedirection, false);
    document.addEventListener('wpcf7invalid', contactFormInvalid, false);

    // Specifix form
    contactUsForm_init();
    searchForm_init();
    jobForm_init();
  }


  // Prefill input[name=to] from email query string
  //
  function assignEmailFromUrl_init() {
    var query_email = getParameterByName("email");
    if(query_email) {
      $("input[name=to]").val(query_email);
    }
  }


  // Autoresize height of textarea based on content inside of it
  // @adapted from: https://stephanwagner.me/auto-resizing-textarea
  //
  function textAreaAutoresize_init() {
    var $textareas = $('form .field-textarea textarea, form .field-textarea-no-floating-label textarea');

    $textareas.attr("col", 0)
              .attr("rows", 0);

    $textareas.each(function() {
      var offset = this.offsetHeight - this.clientHeight;

      var resizeTextarea = function(el) {
        if((el.scrollHeight + offset) + 50 > $window.height()) {
          $(el).css('height', el.scrollHeight + offset);
        }else{
          $(el).css('height', 'auto').css('height', el.scrollHeight + offset);
        }
      };

      $(this).bind('keyup input', function() { resizeTextarea(this); }).removeAttr('data-autoresize');
    });
  }


  // Add focus class on field
  //
  function setFocusClass(e) {
    var $el = $(e.currentTarget);
    $el.parents(".field").addClass("field-focus");
  }


  // Remove focus class on field
  //
  function removeFocusClass(e) {
    var $el = $(e.currentTarget);
    $el.parents(".field").removeClass("field-focus");
  }


  // Add filled class based on field value
  //
  function setFilledClass(e) {
    var $el = $(e.currentTarget);

    $el.parents(".field").toggleClass("field-filled", $el.val() != "");
  }


  // Set radio input checked when user click on radio span label (Contact form 7)
  //
  function setRadioCheckedFromFakeLabel(e) {
    var $el = $(e.currentTarget);
    var $input = $el.parent().find("input");

    if($input.is(":checkbox")) {
      $input.prop("checked", !$input.prop("checked"));
    }else{
      $input.prop("checked", true);
    }

    $input.trigger("change");
  }


  // Set field or field visibility based on link clicked
  //
  function setFieldOrFile(e) {
    e.preventDefault();

    var $el = $(e.currentTarget);
    var $parent = $el.parents(".field-file-or-url");

    $parent.find("> .wpcf7-not-valid-tip").addClass("hide");

    $parent.find($el.data('link')).removeClass("hide");
    $parent.find(".field-file-or-url-choices-cancel").removeClass("hide");

    $parent.find(".field-file-or-url-choices-options").addClass("hide");

  }


  // Cancel current choice and show options again
  //
  function cancelActionFieldOrFile(e) {
    e.preventDefault();

    var $el = $(e.currentTarget);
    var $parent = $el.parents(".field-file-or-url");

    $parent.find("> div").addClass("hide");
    $parent.find(".field-file-or-url-choices-cancel").addClass("hide");

    $parent.find("> div").eq(0).removeClass("hide");
    $parent.find(".field-file-or-url-choices-options").removeClass("hide");

    $parent.find("> .wpcf7-not-valid-tip").removeClass("hide");
  }



  // -----------------------------
  // -----------------------------
  // Contact Us - Form
  // -----------------------------
  // -----------------------------
  function contactUsForm_init() {
    $(".form-dynamic-text-radio input").on("change", contactUsForm_handleRadioChange)
                                       .trigger("change");
  }

  function contactUsForm_handleRadioChange(e) {
    var $input = $(e.currentTarget).parents(".form-dynamic-text-radio").find("input:checked");
    var $textarea_parent = $(".form-dynamic-text-textarea");


    if($input.parent().index() == 1) {
      // Second option
      $textarea_parent.find("label").html($textarea_parent.data("second-option"));
    }else{
      // First option
      $textarea_parent.find("label").html($textarea_parent.data("first-option"));
    }

    // Add reason in the redirect URL
    var $redirect_input = $("input[name='redirect_url']");
    if($redirect_input.length > 0) {
      var original_url = $redirect_input.val().split("?")[0];

      var $label = $input.next(".wpcf7-list-item-label");
      var label_values = $label.text().split(" ");

      $redirect_input.val(original_url+"?reason="+label_values[label_values.length - 1]);
    }
  }



  // -----------------------------
  // -----------------------------
  // Contact form 7
  // -----------------------------
  // -----------------------------
  function contactFormRedirection(event) {
    redirectUrl = $('input[name=redirect_url]').val();

    if($("input[name='newsletter[]']:checked").length > 0) {
      // If newsletter checkbox
      var ajax = General.sendEmailToMailchimp($("#iEmail").val());
      ajax.done(function(data) {
        // Final redirection
        if(redirectUrl != undefined) {
          window.location = redirectUrl;
        }
      });
    }else{
      // Final redirection
      if(redirectUrl != undefined) {

        $.urlParam = function (name) {
          var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
          return (results !== null) ? results[1] || 0 : false;
        }
        var queryParam = $.urlParam('poste');
        var emailSent = $('#iEmail').val();

        if(queryParam) {
          window.location = redirectUrl + "?poste=" + queryParam + "&email=" + emailSent;
        }
        else {
          window.location = redirectUrl;
        }
      }
    }
  }


  function contactFormInvalid(event) {
    // Field file or URL show error when not filled and required!
    $(".field.field-file-or-url").each(function() {
      var $field = $(this);
      $field.find("> .wpcf7-not-valid-tip").remove();
      var $errors = $field.find(".wpcf7-not-valid-tip");

      if($errors.length > 0) {
        $field.addClass("error");
        $field.append(sprintf('<span role="alert" class="wpcf7-not-valid-tip">%s</span>', $errors.eq(0).text()));
      }else{
        $field.removeClass("error");
      }
    });


    // Trigger same height elements
    setTimeout(function() {
      window.$window.trigger("resize");
    }, 500);
  }


  // -----------------------------
  // -----------------------------
  // Search - Form
  // -----------------------------
  // -----------------------------
  function searchForm_init() {
    $search = $("input#s");

    $search.attr("placeholder", ($("html").attr("lang") == "fr" ? "Rechercher" : "Search"));
    $search.on("keyup", searchForm_handleChange);
  }

  function searchForm_handleChange() {
    $search.toggleClass("active", ($search.val() != ""));
  }



  // -----------------------------
  // -----------------------------
  // Job - Form
  // -----------------------------
  // -----------------------------
  function jobForm_init() {
    if(is_page("page-template-template-job") || is_page("page-template-template-candidature")) {

      // Translate job option text
      if(is_page("en")) {
        $("option[value='Chargé(e) de projets web']").text("Web Project Manager");
        $("option[value='Designer UX']").text("UX Designer");
        $("option[value='Designer Web (UI)']").text("Web Designer (UI)");
        $("option[value='Développeur(euse) applications mobiles']").text("Mobile App Developer");
        $("option[value='Développeur(euse) Web Back-End']").text("Back-end Web Developer");
        $("option[value='Développeur(euse) Web Front-End']").text("Front-end Web Developer");
        $("option[value='Intégrateur(trice) Web']").text("Web integrator");
        $("option[value='Rédacteur(rice)']").text("Editor");
        $("option[value='Responsable Marketing Web']").text("Web Marketing Manager");
        $("option[value='Spécialiste en Analytique Web']").text("Web Analytics Specialist");
        $("option[value='Stratège de contenus et médias sociaux']").text("Content and Social Media Strategist");
        $("option[value='Stratège Web']").text("Web Strategist");
        $("option[value='Traducteur(rice)']").text("Translator");
        $("option[value='Autre']").text("Other");
      }

      // Job select
      $job_select = $("select[name=job]");
      $job_select.find("option[value='']").text("");


      if(window.job_type) {
        if($job_select.find("option[value='"+window.job_type+"']").length > 0) {
          $job_select.find("option[value='"+window.job_type+"']").prop("selected", true);
          $job_select.parent().parent().addClass("hide");
          $(".field-phone").addClass('all-width');
        }
      }

      // Set job_title field
      if(window.job_type) {
        $("input[name=job_title]").val(window.job_type)
      }
    }
  }
}

// Push class in bootstack
arrBootStack.push(Form);
var General = new function() {
  var _self = this;

  var page_transition_variables = {
    min_loading: 100,
    max_loading: 3000,
    time_loading: 0,
    time_start: 0,
    timer: null,
    active: true,
  };

  var menuWidth = 1150;

  var $career_circle,
      previous_scroll_top = 0;

  this.initialize = function () {
    // Variables
    $career_circle = $(".career-circle");
    var previous_scroll_top = window.$window.scrollTop();
    var $first_sub_menu = document.querySelectorAll(".menu-item-has-children.expertise .sub-menu")[0];    
    var $second_sub_menu = document.querySelectorAll(".menu-item-has-children.analyse .sub-menu, .menu-item-has-children.strategie .sub-menu, .menu-item-has-children.conception .sub-menu, .menu-item-has-children.optimisation .sub-menu");
    var $mobile_sub_menu_back_button = document.getElementsByClassName("svg-btn-arrow-left");

    $($first_sub_menu).addClass("first-sub-menu");
    $($second_sub_menu).addClass("second-sub-menu");

    // HTML support
    if(Modernizr.svg) {
      window.$body.addClass("svg");
    }

    initLeonardGTMTracking();

    // Headers
    //window.$window.on("scroll", headers_handleSticky);

    $(".categories-selector > li, .authors-selector > li").on("mouseover", blogHeader_DropdownHover)
                                                          .on("mouseleave", blogHeader_DropdownLeave)
                                                          .on("click", "> a", blogHeader_DropdownClick);

    var window_width = window.$window.width();

    $("#mobile-menu-button").on("click", header_mobileNavigation);
    $(".leonard-main-nav > li.menu-item-has-children > a").on("click", header_openSubMenu);

    $(window).on('resize', leonardResize);

    
    if(window_width <= 1150) {
      $(".svg-btn-arrow-left").on("click", header_mobileBackButtonNavigation);
      $("#mobile-sub-menu-button").on("click", header_mobileSubMenuNavigation);
      $(".leonard-main-nav li.expertise").on("click", toggleMobileSubMenu);
      $(".leonard-main-nav li.expertise").on("click", onClickExpertiseSubMenuMobileOpen);
    }

    // Set mobile language link

    $(".wpml-ls-legacy-list-horizontal li:not(.wpml-ls-current-language) a")

    $(".show-on-mobile.mobile-language a").attr("href", $(".wpml-ls-legacy-list-horizontal li:not(.wpml-ls-current-language) a").attr("href"))
                                          .html($(".wpml-ls-legacy-list-horizontal li:not(.wpml-ls-current-language) a .wpml-ls-native").text());


    // Green frame
    window.$window.on("scroll", greenFrame_scrollCursor_handleScroll);
    window.$window.on("beforeunload", greenFrame_showLoadingTransition);
    $(".body-frame").removeClass("body-frame-transition-exit");
    setTimeout(function() {
      $(".body-frame").addClass("body-frame-completed");
    }, 2000);

    // Excerpts listing
    sameHeight($(".excerpts-listing.excerpts-listing-two-columns .excerpts-listing-item-content"), 9999, 1024, "height");

    // Black block
    sameHeight($(".black-content-blocks .blocks-block"), 9999, 900, "outerHeight");
    sameHeight($(".black-content-blocks.green .blocks-block"), 9999, 900, "outerHeight");

    //LP
    sameHeight($(".processus-tile"), 9999, 900, "outerHeight");
    sameHeight($(".blocks-amazon .blocks-block"), 9999, 900, "outerHeight");

    // Related articles
    sameHeight($(".container-related-article .title"), 9999, 900, "outerHeight");
    sameHeight($(".container-related-article .date-author"), 9999, 900, "outerHeight");
    sameHeight($(".container-related-article .description"), 9999, 900, "outerHeight");
    sameHeight($(".container-related-article .container-thumbnail img"), 9999, 900, "outerHeight");

    // Square item
    $(".squared-item .squared-item-content").each(function(index, value) {
      var $el = $(this);
      var $title = $el.find(".squared-item-title");

      var bottom_value = $el.outerHeight() - ($title.height() / 2);

      $el.css("bottom", -1*bottom_value);
    });


    // Redirect to children link
    $(".redirect-to-children").on("click", redirectToChildrenLink);

    // Scroll to target
    $(".scroll-to").on("click", scrollToElement);

    // Target window
    $(".targeted-window").on("click", function(e) {
      e.preventDefault();

      var target_window_width = 600;
      var target_window_height = 400;
      var x = (window.$window.width() / 2) - (target_window_width / 2);
      var y = (window.$window.height() / 2) - (target_window_height / 2);

      window.open($(this).attr("href"),'targetWindow', sprintf('width=%s,height=%s,left=%s,top=%s', target_window_width, target_window_height, x, y));
      return false;
    });

    // Careers
    careers_print_log();
    window.$window.on("scroll", careers_handleFooterCircleButtonVisiblity);


    // Newsletter subscription (Generic function)
    $(".newsletter-api").on("submit", newsletter_handleForm);


    // Shorcode
    if($(".social-advantage").length > 0) {
      window.$window.on("scroll", handleSocialAdvantagesVisiblity);
    }

    if($(".content-meta .search-icon").length > 0) {
      $(".content-meta .search-icon").on("click", function() {
        $(".leonard-search-wrapper").toggleClass("search-open");
      });
    }

    $(document).on('keyup', '#mobile-leonard-search-input', leoDelay(ajaxSearch, 300));
    $(document).on('keyup', '#leonard-search-input', leoDelay(ajaxSearch, 300));
    $(document).on('keyup', '#leonard-searchpage-input', leoDelay(ajaxSearch, 300));
    $(document).on('keyup', '#blog-search-input', leoDelay(ajaxSearch, 300));

    $("#leonard-search-input").on('search', ajaxClearSearch);
  }


  // -----------------------------
  // -----------------------------
  // Sticky header
  // -----------------------------
  // -----------------------------
  function headers_handleSticky() {
    var scroll_top = window.$window.scrollTop();
    var window_width = window.$window.width();
    var is_scrolling_up = previous_scroll_top > scroll_top;

    // Main header
    // --------
    if(is_scrolling_up) window.$body.removeClass("header-sticky-first-time");

    window.$body.toggleClass("header-sticky-show", is_scrolling_up);

    if(scroll_top >= 141 && !window.$body.hasClass("header-sticky")) {
      window.$body.addClass("header-sticky header-sticky-first-time");
    }else if((scroll_top <= 35 && window_width > 900) || (scroll_top <= 0 && window_width <= 900)) {
      window.$body.removeClass("header-sticky");
    }

    // Blog header
    // ---------
    if(is_page("single")) {
      var $singleNavigation = $(".single-navigation");
      var singleNavigationBottom = $singleNavigation.offset().top + $singleNavigation.outerHeight();

      window.$body.toggleClass("single-sticky", (singleNavigationBottom <= scroll_top));
    }

    // Careers header
    // ---------
    if(is_page("page-id-41") || is_page("page-id-63")) {
      var $careersNavigation = $(".careers-introduction-navigation");
      var careersNavigationBottom = $careersNavigation.offset().top + $careersNavigation.outerHeight();

      window.$body.toggleClass("careers-sticky", (careersNavigationBottom <= scroll_top));
    }

    // Return button
    if(scroll_top > 141) {
      $(".body-frame-link-button").addClass("push");
    }else{
      $(".body-frame-link-button").removeClass("push");
    }

    previous_scroll_top = scroll_top;
  }




  // -----------------------------
  // -----------------------------
  // Blog header
  // -----------------------------
  // -----------------------------
  function blogHeader_DropdownHover(e) {
    if(window.$window.width() > 1024) {
      var $target = $(e.currentTarget).find("ul");
      $target.css("max-height", find_hidden_height($target));
    }
  }

  function blogHeader_DropdownLeave(e) {
    if(window.$window.width() > 1024) {
      $(e.currentTarget).find("ul").css("max-height", 0);
    }
  }

  function blogHeader_DropdownClick(e) {
    e.preventDefault();

    if(window.$window.width() <= 1024) {
      var $target = $(e.currentTarget).parent().parent().find("ul");

      if($target.css("max-height") == "0px") {
        $target.css("max-height", find_hidden_height($target));
      }else{
        $target.css("max-height", 0);
      }
    }
  }


  // -----------------------------
  // -----------------------------
  // Mobile navigation
  // -----------------------------
  // -----------------------------
  function header_mobileNavigation(e) {
    e.preventDefault();

    var $el = $(e.currentTarget);
    if($el.hasClass("open")) {
      // Close menu...
      $el.removeClass("open");
      window.$body.removeClass("open-mobile-menu");
      $("html").attr("style", null);
    }else{
      // Open menu
      $el.addClass("open");
      window.$body.addClass("open-mobile-menu");
      $("html").css("overflow-y", "hidden");
    }
  }
  

  // -----------------------------
  // -----------------------------
  // Mobile sub menu navigation
  // -----------------------------
  // -----------------------------

  
  function onClickExpertiseSubMenuMobileOpen() {
    return false;
  }

  function toggleMobileSubMenu() {
    var $hamburgerMenuTwo = document.getElementsByClassName("component-toggle-hamburger-menu-2");
    var $hamburgerMenu = document.getElementsByClassName("component-hamburger-menu");
    var $backHamburgerMenu = document.getElementsByClassName("component-back-hamburger-menu");
    var $hamburgerMenuBlockAnimate = document.getElementsByClassName("block-animate");
    
    $hamburgerMenuTwo[0].style.left = "0px";
    $hamburgerMenu[0].style.opacity = "1";
    $backHamburgerMenu[0].style.opacity = "1";
    $hamburgerMenuBlockAnimate[0].style.width = "100%";
  }

  function header_mobileBackButtonNavigation() {
    var $hamburgerMenuTwo = document.getElementsByClassName("component-toggle-hamburger-menu-2");
    var $hamburgerMenu = document.getElementsByClassName("component-hamburger-menu");
    var $backHamburgerMenu = document.getElementsByClassName("component-back-hamburger-menu");
    var $hamburgerMenuBlockAnimate = document.getElementsByClassName("block-animate");
    
    $hamburgerMenuTwo[0].style.left = "100%";
    $hamburgerMenu[0].style.opacity = "0";
    $backHamburgerMenu[0].style.opacity = "0";
    $hamburgerMenuBlockAnimate[0].style.width = "0px";
  }

  function header_mobileSubMenuNavigation(e) {
    header_mobileBackButtonNavigation();
    var $hamburgerMenuButton = document.getElementById("mobile-menu-button");

    e.preventDefault();
    var $el = $(e.currentTarget);

    if($el.hasClass("open")) {
      // Close menu...
      $($hamburgerMenuButton).removeClass("open");
      window.$body.removeClass("open-mobile-menu");
      $("html").attr("style", null);
    }
  }

  // -----------------------------
  // -----------------------------
  // Green frame
  // -----------------------------
  // -----------------------------

  // Handle scroll position for scrollCursor
  //
  function greenFrame_scrollCursor_handleScroll(e) {
    var scrollPosition = window.$window.scrollTop();

    // Bézier path
    if(scrollPosition <= 47) {
      $(".svg-scroll-shape path").attr("d", scrollCursor_generateNewPath(window.$window.scrollTop()));
    }else if(scrollPosition = 48) {
      $(".svg-scroll-shape path").attr("d", "");
    }

    // Opacity & position mouse
    if(scrollPosition <= 48) {
      var opacity = 1 - (scrollPosition * 1) / 48;

      if(opacity == 1) { opacity = null; }

      $(".body-frame-mouse").css({
        opacity: opacity,
        transform: "translate(0, "+scrollPosition+"px)",
      });
    }
  }

  // Generate the a new bézier curve base on incrementer
  //
  function scrollCursor_generateNewPath(incrementer) {
    if(typeof incrementer == "undefined" || incrementer == 0) {
      return "m97.549 1c44.343-.583 37.778 47.005 91.539 47.005h-183c50.999 0 47.118-46.423 91.461-47.005z";
    }else{
      var first_arg = incrementer;                      // +1
      var second_arg = 48 - (incrementer * 0.995);      // 48 -.995
      var third_arg = 48 - (incrementer * 0.995);       // 48 -.995
      var fourth_arg = 47.418 - (incrementer * 0.995);  // 47.418 -.995
      var fifth_arg = 48 - (incrementer * 0.995);       // 48 -.995

      var path = "m97.549 %sc44.343-.583 37.778 %s 91.539 %sh-183c50.999 0 47.118-%s 91.461-%sz";
      return sprintf(path, first_arg, second_arg, third_arg, fourth_arg, fifth_arg);
    }
  }


  // Show loading transition
  //
  function greenFrame_showLoadingTransition(e) {
    var destination = document.activeElement.href;

    // Ignore mailto and tel links
    if(typeof destination == "undefined" || (destination.indexOf("mailto") == -1 && destination.indexOf("tel") == -1)) {
      $(".body-frame").addClass("body-frame-transition-exit");
    }
  }


  // Hover return button in green frame
  //
  function greenFrame_returnLinkHover(e) {
    $(".body-frame-link-shape").addClass("hover");
  }

  // Leave return button in green frame
  //
  function greenFrame_returnLinkLeave(e) {
    $(".body-frame-link-shape").removeClass("hover");
  }


  // -----------------------------
  // -----------------------------
  // Careers
  // -----------------------------
  // -----------------------------


  // Print in console log comment in the header
  //
  function careers_print_log() {
    var html = $('html').html();
    var open_comment_index = html.indexOf("<!--");
    var close_comment_index = html.indexOf("-->");

    var careers_comment = html.substring(open_comment_index, close_comment_index)
                              .replace("<!--\n", "");
    careers_comment = careers_comment.split("\n");

    for (var i = 0; i < careers_comment.length; i++) {
      if(careers_comment[i] != "") {
        console.log(careers_comment[i]);
      }
    }
  }


  // When the footer is visible in the middle of the screen we show the careers circle button
  //
  function careers_handleFooterCircleButtonVisiblity(e) {
    var window_bottom = window.$window.scrollTop() + window.$window.height();
    if(window.$window.width() > 1200) {
      window_bottom -= 250;
    }else if(window.$window.width() <= 640){
      window_bottom -= $career_circle.outerHeight() + 70;
    }

    if($career_circle.length > 0) {
      if($career_circle.offset().top < window_bottom) {
        $career_circle.addClass("show");
      }else{
        $career_circle.removeClass("show");
      }
    }
  }



  // -----------------------------
  // -----------------------------
  // Newsletter forms
  // -----------------------------
  // -----------------------------

  function newsletter_handleForm(e) {
    e.preventDefault();
    var $el = $(e.currentTarget);

    if($el.find("input[type=email]").val().indexOf("@") !== false) {
      $el.find("button, input[type=submit]").prop("disabled", true);
      $el.find(".newsletter-api-error").remove();
      $el.find(".newsletter-api-loading").removeClass("hide");

      var ajax = _self.sendEmailToMailchimp($el.find("input[type=email]").val());

      ajax.done(function(data) {
        $el.find("button, input[type=submit]").prop("disabled", false);
        $el.find(".newsletter-api-loading").addClass("hide");

        if(data.succes === 1) {
          // Success
          $el.find(".newsletter-api-form *").hide();
          $el.find(".newsletter-api-form").append("<p class='newsletter-api-success' style='display: none;'>"+data.message+"</p>");
          $el.find(".newsletter-api-form .newsletter-api-success").fadeIn();
        }else{
          $el.find(".newsletter-api-form").append("<p class='newsletter-api-error style='display: none;''>"+data.message+"</p>");
          $el.find(".newsletter-api-form .newsletter-api-error").fadeIn();
        }
      });
    }
  }


  // Send email to mailchimp list
  //
  // @return Ajax object
  this.sendEmailToMailchimp = function(email) {
    var data = {
      language: $("html").attr("lang"),
      email: email
    };

    return $.ajax({
      url: '/wp-content/themes/leonard/api/mailchimp_subscription.php',
      type: 'POST',
      dataType: 'json',
      data: data,
    });
  }


  // Handle social advantages visibility on scroll
  //
  function handleSocialAdvantagesVisiblity(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height() - (window.$window.height() / 5);

    $(".social-advantage").filter(":not(.visible)").each(function() {
      var $socialAdvantage = $(this);
      if($socialAdvantage.offset().top < scroll_bottom) {
        $socialAdvantage.addClass("visible");
      }
    });
  }


  // Leonard GTM tracking initialize
  //
  function initLeonardGTMTracking() {
    var arrLeonardGTMTrackingFormPath = [
      "/nous-joindre/",
      "/soumettre-projet/",

      "/en/contact-us/",
      "/en/submit-project/",
    ];


    // Track CTA pointing to a «Leads Form»
    // -------
    var arrLeonardGTMTrackingCTA = [];
    for(var i=0; i<arrLeonardGTMTrackingFormPath.length; i++){
      arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
    }

    // Custom CSS rules here
    // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");


    // Custom actions
    $('input[type="radio"]').filter(function() {
      var input_name = $(this).attr('value').toLowerCase();

      return (input_name.indexOf('projet') > -1 || input_name.indexOf('project') > -1);
    }).parent().addClass("gtm-cta-4");

    // $("input[value*='question'], input[value='I have a question'").parent().addClass("gtm-cta-5");
    $('input[type="radio"]').filter(function() {
      var input_name = $(this).attr('value').toLowerCase();

      return input_name.indexOf('question') > -1;
    }).parent().addClass("gtm-cta-5");



    $("[data-fancybox], a.fancybox").addClass("gtm-lightbox");


    $.urlParam = function (name) {
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
      return (results !== null) ? results[1] || 0 : false;
    }
    var queryParam = $.urlParam('poste');

    if(!queryParam) {
      console.log('No Query Param');
      $('.custom-section.candidature form .field.field-submit .wpcf7-submit').removeClass('gtm-cta-3').addClass('gtm-cta-6');
    }

    $('.candidature-merci .candidature-merci-questions .candidature-merci-submit').addClass('gtm-cta-7');


    $(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

    // Track «Leads form» submit button click
    // -------
    if(arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
      $("form button, form input[type=submit]").addClass("gtm-form-submited");
    }
  }

  function header_openSubMenu(e){
    if(window.innerWidth < menuWidth){
      e.preventDefault();
      leonardOpenSubMenu(this);
    }
  }
  function leonardOpenSubMenu(el){
    var allSubMenu = $(el).parent().parent().find('.sub-menu').not($(el).parent().find('.sub-menu'))
    var subMenuSelected = $(el).parent().find('.sub-menu');

    allSubMenu.removeClass('sub-menu-opened');
    subMenuSelected.toggleClass('sub-menu-opened');
    
    $(el).parent().parent().find('a').not($(el)).removeClass('leonard-sub-menu-selected');
    $(el).toggleClass('leonard-sub-menu-selected');
  }
  function leonardResize(e){
		var winWidth = window.innerWidth;

    if(winWidth > menuWidth){
      $('.leonard-main-nav .sub-menu').removeClass('sub-menu-opened');
      $('.leonard-main-nav > li > a').removeClass('leonard-sub-menu-selected');

      $('body').removeClass('open-mobile-menu');
      $('#mobile-menu-button').removeClass('open');  
    }
  }

  function ajaxSearch(e){
    var perPage = 6;
    var paginate = 0;
    var postTypes = ['page', 'post'];
    var isBlog = false;
    var language = $("html").attr("lang");

    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var location = urlParams.get('location');

    if(e.target.id == 'leonard-searchpage-input'){
      perPage = 12;
      paginate = 1;
    }
    if(e.target.id == 'blog-search-input' || location == 'blog'){
      isBlog = true;
      postTypes = ['post'];
    }

    if($(this).val() == ''){
      ajaxClearSearch(e);
    }
    else{
      $.ajax({
        beforeSend: function(){
          $(".search-loading").css('display', 'inline-flex');
        },
        url: ajaxurl,
        type: 'post',
        data: {
          action: 'leonard_search_results',
          keyword: $(this).val(),
          perPage: perPage,
          paginate: paginate,
          postTypes: postTypes,
          isBlog: isBlog,
          language: language
        },
        success: function(data) {
          if(e.target.id == 'leonard-searchpage-input'){
            $('.search-page #leonard_searchpage_results').html(data);
          }
          else if(e.target.id == 'blog-search-input'){
            $('#blog_search_results .inner').html(data);
          }
          else if(window.innerWidth < menuWidth) {
            $('.mobile-menu #leonard_search_results').html(data);
          }
          else {
            $('.leonard-search-wrapper #leonard_search_results').html(data);
          }
            
          $(".search-loading").css('display', 'none');
        }
      });
    }
  }

  function ajaxClearSearch(e){
    if(e.target.id == 'leonard-searchpage-input'){
      $('#leonard_search_results').empty();
    }
    else{
      $('#leonard_search_results').empty();
    }
  }

  function leoDelay(callback, ms) {
    var timer = 0;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }
}

// Push class in bootstack
arrBootStack.push(General);
// This class handle «horizontal step process» component
//
var HorizontalStepProcess = new function() {
  var _self = this,
      $horizontalStepProcesses = [];

  this.initialize = function () {
    $horizontalStepProcesses = $(".custom-section.horizontal-step-process");
    if($horizontalStepProcesses.length > 0) {
      window.$window.on("resize", setPaddingTopOfColumns);
      window.$window.on("scroll", handleStepsVisiblity);
    }
  }


  // Set minimum height for dark circle full
  //
  function setPaddingTopOfColumns() {
    if(window.$window.width() > 1024) {
      $horizontalStepProcesses.each(function() {
        var $horizontalStepProcess = $(this);

        var maxHeight = 0;
        $horizontalStepProcess.find(".horizontal-step-process-step-title").each(function() {
          if(maxHeight < $(this).outerHeight()) {
            maxHeight = $(this).outerHeight();
          }
        });


        $horizontalStepProcess.find(".horizontal-step-process-step").css("padding-top", (maxHeight + 40));
      });
    }else{
      $horizontalStepProcesses.find(".horizontal-step-process-step").css("padding-top", 0);
    }
  }


  // Handle steps visibility on scroll
  //
  function handleStepsVisiblity(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height() - (window.$window.height() / 5);

    $horizontalStepProcesses.filter(":not(.visible)").each(function() {
      var $step = $(this);
      if($step.offset().top < scroll_bottom) {
        $step.addClass("visible");
      }
    });

  }
}

// Push class in bootstack
arrBootStack.push(HorizontalStepProcess);
// This class handle job-conclusion component
//
var JobConclusion = new function() {
  var _self = this,
      $jobConclusions;

  this.initialize = function () {
    $jobConclusions = $(".custom-section.job-conclusion");

    if($jobConclusions.length > 0) {
      window.$window.on("scroll", handleJobConclusionVisiblity);
    }

    var acc = document.getElementsByClassName("job-conclusion-question");
    var i;
    
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        if(this.classList.contains('close')) {
          this.classList.remove('close');
          this.classList.add('open');
        }
        else {
          this.classList.remove('open');
          this.classList.add('close');
        }
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        } 
      });
    }
  }


  // Handle jobConclusions visibility on scroll
  //
  function handleJobConclusionVisiblity(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height() - (window.$window.height() / 5);

    $jobConclusions.find(".job-conclusion-advantage, .job-conclusion-image").filter(":not(.visible)").each(function() {
      var $jobConclusion = $(this);
      if($jobConclusion.offset().top < scroll_bottom) {
        $jobConclusion.addClass("visible");
      }
    });
  }


}

// Push class in bootstack
arrBootStack.push(JobConclusion);
// This class handle job introduction» component
//
var JobIntroduction = new function() {
  var _self = this,
      $jobIntroductions;

  this.initialize = function () {
    $jobIntroductions = $(".custom-section.job-introduction");
    if($jobIntroductions.length > 0) {
      $jobIntroductions.each(function() {
        sameHeight($(this).find(".left-content, .right-content"), 9999, 900, "height");
      });
    }
  }
}

// Push class in bootstack
arrBootStack.push(JobIntroduction);
// This class handle job introduction» component
//
var JobIntroduction = new function() {
  var _self = this;

  this.initialize = function () {
    if($('.second-block-carousel').length) {
      $('.second-block-carousel').slick({
        slidesToShow    : 1,
        slidesToScroll  : 1,
        lazyLoad        : 'progressive',
        variableWidth   : true,
        centerMode      : true,
        dots            : false,
        draggable       : false,
        responsive      : [
          {
            breakpoint: 600,
            settings: {
              draggable       : true,
            }
          },
        ]
      });
    }

    sameHeight($(".second-block-realisation .realisation-text"));

  }
}

// Push class in bootstack
arrBootStack.push(JobIntroduction);
// This class handle «latest articles & resources» component
//
var LatestArticlesResources = new function() {
  var _self = this,
      $resources = [];

  this.initialize = function () {
    $resources = $(".latest-articles-resources");

    if($resources.length > 0) {
      $resources.on("click", ".excerpts-listing-item", redirectToChildrenLink);

      $resources.each(function() {
        var $resource = $(this);
        sameHeight($resource.find(".excerpts-listing-item .excerpts-listing-item-content"), 9999, 1024, "height");

        setTimeout(function() {
          sameHeight($resource.find(".row > div:not(.gr-24)"), 9999, 1024, "height");
        }, 250);
      })
    }
  }
}

// Push class in bootstack
arrBootStack.push(LatestArticlesResources);

// This class set the background-image for an element based on data attributes and window width
//
// Attributes required
// - data-lazy-image::String            Url of the default image
// - data-lazy-image-{size}::String     Url for a specific width (ex: data-lazy-image-900)
//
var LazyImageLoader = new function() {
  var _self = this,
      $lazyImages = [];

  this.initialize = function () {
    $lazyImages = $("[data-lazy-image]");
    if($lazyImages.length > 0) {
      window.$window.on("resize", setLazyImagesBackground);
    }
  }


  // Set the image background based on window with
  function setLazyImagesBackground(e) {
    var window_width = window.$window.width();

    $lazyImages.each(function() {
      var $el = $(this);

      // Resverse sizes order
      var sizes = $el.data("lazy-image-sizes");
      var reverted_keys = Object.keys(sizes).map(Number).sort(function(a,b) {return b - a;});

      // Find the size of the image we should show based on element attributes
      var path = $el.data("lazy-image");
      for(var i=0; i < reverted_keys.length; i++) {
        if(window_width <=  reverted_keys[i]) {
          path = sizes[reverted_keys[i]];
        }
      }

      // Set background for the curretn element
      $el.css({"backgroundImage": sprintf("url('%s')", path)});
    });
  }
}

// Push class in bootstack
arrBootStack.push(LazyImageLoader);

// This class handle lp-client
//
var LpClient = new (function () {
  var _self = this,
    $client;
  this.initialize = function () {
    $client = $("body.page-template-template-lp-client");

    if (window.$window.width() < 650) {
      $('.lp-client-hand').addClass('no-animation');
    }

    if ($client.length > 0) {
      window.$window.on("scroll", introAnimation);
    }
  };

  // Handle intro animation on scroll
  //
  function introAnimation(e) {
    var offset1 = 30;
    var offset2 = 130;

    if (window.$window.width() < 650) {
      offset2 = 90;
    }

    if (window.$window.scrollTop() >= 0) {
      $(".lp-client-background-text.first").addClass("show");
    }
    if (window.$window.scrollTop() > offset1) {
      $(".lp-client-background-text.second").addClass("show");
    }
    if (window.$window.scrollTop() > offset2) {
      $(".lp-client-background-text.third").addClass("show");
    }
  }
})();

// Push class in bootstack
arrBootStack.push(LpClient);

jQuery(document).ready(function () {
  jQuery('.items-slider').slick({
    arrows: true,
    mobileFirst: true,
    prevArrow: "<img class='a-left control-c prev slick-prev' src='wp-content/themes/leonard/images/icons/ico-arrow-slider-prev.svg' width='75''>",
    nextArrow: "<img class='a-right control-c next slick-next' src='wp-content/themes/leonard/images/icons/ico-arrow-slider-next.svg' width='75''>"
  });
});
// This class handle lp-promo
//
var LpPromo = new (function () {
  var _self = this,
    $promo;

  this.initialize = function () {
    $promo = $("body.page-template-template-lp-promo");

    if ($promo.length > 0) {
      window.$window.on("scroll", introAnimation);
    }
  };

  // Handle intro animation on scroll
  //
  function introAnimation(e) {
    var offset1 = 30;
    var offset2 = 130;

    if (window.$window.width() < 650) {
      offset2 = 90;
    }

    if (window.$window.scrollTop() >= 0) {
      $(".intro .text_1").addClass("show");
    }
    if (window.$window.scrollTop() > offset1) {
      $(".intro .text_2").addClass("show");
    }
    if (window.$window.scrollTop() > offset2) {
      $(".intro .text_3").addClass("show");
    }
  }
})();

// Push class in bootstack
arrBootStack.push(LpPromo);

// This class handle «our clients» component
//
var OurClients = new function() {
  var _self = this,
      $clients = [];

  this.initialize = function () {
    $clients = $(".our-clients");
    if($clients.length > 0) {
      $clients.each(function() {
        var $client = $(this);
        sameHeight($client.find(".our-clients-left, .our-clients-spacer, .our-clients-right"), 9999, 900, "height");
      })
    }
  }
}

// Push class in bootstack
arrBootStack.push(OurClients);

// This class handle «page introduction» and «page job introduction» component
//
var PageIntroduction = new function() {
  var _self = this,
      $pageIntroduction, $pageJobIntroduction, $singleIntroduction;

  this.initialize = function () {
    $pageIntroduction = $(".page-introduction");
    $pageJobIntroduction = $(".page-job-introduction");
    $singleIntroduction = $(".single-introduction").not('.long-introduction');
    //$singleLongIntroduction = $(".long-introduction");
    $pageBackground = $(".job-background-src");

    if($pageJobIntroduction.length > 0) {
      // Page job introduciton
      // ------------
      window.$window.on("resize", setJobHeight);

      var $testimonials = $pageJobIntroduction.find(".page-job-introduction-testimonial");

      if($testimonials.length > 1) {
        var random_int = getRandomInt(0, ($testimonials.length-1));
        $testimonials.eq(random_int).removeClass("hide");
      }else{
        $testimonials.eq(0).removeClass("hide");
      }
    }else if($singleIntroduction.length > 0) {
      // Single introduction
      // ------------
      // window.$window.on("resize", setSingleHeight);
    }else if($pageIntroduction.length > 0){
      // Page introduction
      // ------------
      // window.$window.on("resize", setHeight);
    }

    if($pageBackground.length > 0) {
      $pageJobIntroduction.css('background', 'url(' + $pageBackground.data('background') + ') center no-repeat');
      $pageJobIntroduction.css('background-size', 'cover');
    }
  }


  // Set height for page introduction
  //
  function setHeight() {
    if(window.$window.height() > 560) {
      var slideshow_height = window.$window.height() - $(".leonard-meta-nav").outerHeight() - 6;

      $pageIntroduction.css("minHeight", slideshow_height);
    }else{
      $pageIntroduction.css("minHeight", null);
    }
  }


  // Set height for single-introduction
  //
  function setSingleHeight() {
    if(window.$window.width() > 1024) {
      var slideshow_height = window.$window.height() - $(".leonard-meta-nav").outerHeight() - 6;
      /*if($singleLongIntroduction.length){
        var content_height = $('.long-introduction-content').height() + 200;
        $singleIntroduction.css("minHeight", content_height);
      }
      else{*/
        $singleIntroduction.css("minHeight", slideshow_height);
     // }
    }else{
      $singleIntroduction.css("minHeight", null);
    }
  }


  // Set height page job introduction
  //
  function setJobHeight() {
    if(window.$window.height() > 560) {
      var slideshow_height = window.$window.height() - $(".leonard-meta-nav").outerHeight() - 6;
      var content_height = $pageJobIntroduction.find(".page-job-introduction-content").outerHeight() + 160;

      if(content_height > slideshow_height) {
        $pageJobIntroduction.css("minHeight", content_height);
      }else{
        $pageJobIntroduction.css("minHeight", slideshow_height);
      }
    }else{
      $pageJobIntroduction.css("minHeight", null);
    }
  }
}

// Push class in bootstack
arrBootStack.push(PageIntroduction);
document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);

  function initParallaxTable() {
  ScrollTrigger.create({
    trigger:".parallax",
    start:"top+=5% top+=40% center",
    end:"bottom-=10% center",
    pin:".parallax-fixed-wrapper",
    scrub:true,
    markers:false,
    pinSpacing: false,
  })
}

  function checkWidthAndInitParallax() {
    if (window.innerWidth >= 1000) {
      initParallaxTable(); 
    }
  }
  if (document.querySelector('.parallax')) {
    window.addEventListener('resize', checkWidthAndInitParallax);
    window.addEventListener('load', checkWidthAndInitParallax);
  }
});

// This class handle «sectors» component
//
var Sectors = new function() {
  var _self = this,
      $sectors;

  this.initialize = function () {
    $sectors = $(".custom-section.sectors");

    if($sectors.length > 0) {
      window.$window.on("scroll", handleBlockVisiblity);
    }
  }


  // Handle sectors visibility on scroll
  //
  function handleBlockVisiblity(e) {
    var scroll_bottom = window.$window.scrollTop() + window.$window.height() - (window.$window.height() / 5);

    $sectors.filter(":not(.visible)").each(function() {
      var $sector = $(this);
      if($sector.offset().top < scroll_bottom) {
        $sector.addClass("visible");
      }
    });
  }


}

// Push class in bootstack
arrBootStack.push(Sectors);
// This class handle «simple text component
//
var SimpleText = new function() {
  var _self = this,
      $simpleTexts = [];

  this.initialize = function () {
    $simpleTexts = $(".custom-section.simple-text");

    if($simpleTexts.length > 0) {
      $(".custom-section.simple-text").each(function() {
        var $divs = $(this).find(".row > div");
        var endBreakpoint = griddleClassToFullWidthBreakpoint($divs.eq(0).attr("class"));

        sameHeight($divs, 9999, endBreakpoint, "outerHeight");
      });
    }

  }
}

// Push class in bootstack
arrBootStack.push(SimpleText);

// This class handle slideshow component
//
var Slideshow = new function() {
  var _self = this,
      $slideshows = [],
      arrTimeout = [],
      slidesInterval = 6500;

  this.initialize = function () {
    $slideshows = $(".custom-section.slideshow");

    if($slideshows.length > 0) {
      // setHeight();
      $slideshows.on("click", ".slideshow-buttons a", handlePagination);

      $slideshows.each(function(index, value) {
        $(this).data("parent-index", index);
        arrTimeout.push(setTimeout(handleTimeout, slidesInterval, $(this)));
      });
    }
  }

  function setHeight() {
    if(window.$window.height() > 500) {
      var slideshow_heigth = window.$window.height() - $(".leonard-meta-nav").outerHeight() - 6;

      $slideshows.css("minHeight", slideshow_heigth)
      $(".slideshow-slide").css("minHeight", slideshow_heigth)
    }
  }


  function handlePagination(e) {
    e.preventDefault();
    var $el = $(e.currentTarget);
    var new_index = $el.data("index");
    var $parent = $el.parents(".custom-section.slideshow");

    switchToIndex($parent, new_index);
  }


  function handleTimeout($slideshow) {
    var max_index = $slideshow.find(".slideshow-slide").length - 1;

    // Set next index
    var next_index = $slideshow.data("index") + 1;
    if(next_index > max_index) {
      next_index = 0;
    }
    switchToIndex($slideshow, next_index);
  }


  function switchToIndex($slideshow, new_index) {
    // Clear timeout
    clearTimeout(arrTimeout[$slideshow.data("parent-index")]);

    // Set parent slide index
    $slideshow.data("index", new_index);

    // Buttons
    $slideshow.find(".slideshow-buttons a").removeClass("current");
    $slideshow.find(".slideshow-buttons a").eq(new_index).addClass("current");

    // Slides
    $slideshow.find(".slideshow-slide").removeClass("current");
    $slideshow.find(".slideshow-slide").eq(new_index).addClass("current");


    // Restart timeout
    arrTimeout[$slideshow.data("parent-index")] = setTimeout(handleTimeout, slidesInterval, $slideshow);
  }
}

// Push class in bootstack
arrBootStack.push(Slideshow);
// This class handle «staffs» component
//
var Staffs = new function() {
  var _self = this,
      $staffs = [];

  this.initialize = function () {
    $staffs = $(".staffs");

    if($staffs.length > 0) {
      $staffs.on("click", ".squared-listing-item", handleClickOnStaff);
      $staffs.find(".squared-listing-item").each(function() {
        var $el = $(this);
        if($el.find("a").length == 1) {
          $el.addClass("force-link-cursor");
        }
      });

      setTimeout(randomPauseForGlitchyLeonard, getRandomInt(1500, 2000));
    }
  }

  // Show trigger staff link if have only one link
  //
  function handleClickOnStaff(e) {
    var $el = $(e.currentTarget);

    var $links = $el.find("a");
    if($links.length == 1) {
      $links.focus();
      redirectToChildrenLink(e);
    }else{
      // Do nothing
    }
  }


  // Make some random pauses on glitchy Leonard
  //
  function randomPauseForGlitchyLeonard() {
    var $glitchyLeonard = $(".glitchy-leonard");

    if($glitchyLeonard.hasClass("paused")) {
      // Activate and long time glitch
      $glitchyLeonard.removeClass("paused");
      setTimeout(randomPauseForGlitchyLeonard, getRandomInt(5000, 7000));
    }else{
      // Desactive for a short time
      $glitchyLeonard.addClass("paused");
      setTimeout(randomPauseForGlitchyLeonard, getRandomInt(1500, 2000));
    }
  }
}

// Push class in bootstack
arrBootStack.push(Staffs);

// This class handle «timeline» component
//
var Timeline = new function() {
  var _self = this,
      $timelines = [];

  this.initialize = function () {
    $timelines = $(".custom-section.timeline");

    if($timelines.length > 0) {
      $timelines.on("click", "h3", switchToStep);

      $timelines.each(function() {
        var $timeline = $(this);
        var $content = $timeline.find(".timeline-steps-layers-layer.current .timeline-steps-layers-layer-short-text")
        var content_height = find_hidden_height($content);
        $content.css("max-height", content_height);
      })


      window.$window.on("resize", setLayersMaxHeight);
      window.$window.on("scroll", setCirclePosition);
    }
  }


  // Switch steps to current element
  //
  function switchToStep(e) {
    var $el = $(e.currentTarget);
    var $step_parent = $el.parent()
    var step_parent_index = $step_parent.parent().find($step_parent).index();

    var $timeline = $el.parents(".timeline");

    // Reset steps
    $timeline.find(".timeline-steps-layers-layer-short-text").css("max-height", 0);
    $timeline.find(".timeline-steps-layers-layer.current").removeClass("current");

    // Set content height
    var $content = $step_parent.find(".timeline-steps-layers-layer-short-text");
    var content_height = find_hidden_height($content);
    $content.css("max-height", content_height);


    // Toggle other classes
    $step_parent.addClass("current");


    // Set circle...
    $layers = $timeline.find(".timeline-steps-circles-circle");
    $layers.slice(0, step_parent_index).removeClass("past current futur").addClass("past");
    $layers.eq(step_parent_index).removeClass("past current futur").addClass("current");
    $layers.slice(step_parent_index+1).removeClass("past current futur").addClass("futur");
  }


  // Set layer maxheight
  //
  function setLayersMaxHeight(e) {
    $timelines.each(function() {
      var $el = $(this);
      var $layers = $el.find(".timeline-steps-layers-layer");


      // 1) Open layer height estimation
      var current_layer_max_height = 0;
      $layers.find(".timeline-steps-layers-layer-short-text").each(function() {
        var h = find_hidden_height($(this));
        current_layer_max_height = h > current_layer_max_height ? h : current_layer_max_height;
      });
      var current_layer_padding_top = 110;
      var current_layer_padding_bottom = 110;
      var current_layer_title_height = 55;


      // 2) Closed layers height estimation
      var closed_layers_height = 42 * $layers.not(".current").length;

      // 3) Layers parent max height estimation
      var max_height_layers = 0;
      max_height_layers += current_layer_max_height + current_layer_padding_top + current_layer_padding_bottom + current_layer_title_height;
      max_height_layers += closed_layers_height;


      // 4) Apply max height
      $el.find(".timeline-steps-layers").css("min-height", max_height_layers);

    });
  }


  // Set circle position on mobile
  //
  function setCirclePosition(e) {
    if(window.$window.width() <= 640) {
      var scroll_top = window.$window.scrollTop() + (window.$window.height() / 10);
      var scroll_bottom = window.$window.scrollTop() + (window.$window.height() / 2);

      var $parent = $(".timeline-steps-layers");
      var top_limit = $parent.offset().top;
      var bottom_limit = top_limit + $parent.outerHeight() - 40;

      var $circles = $(".timeline-steps-circles-circle");
      var $circle_current = $circles.filter(".current");

      if(scroll_top >= top_limit && scroll_bottom <= bottom_limit) {
        $circles.css("transform", "translate3d(0, "+(scroll_top - top_limit)+"px, 0)");
      }
    }
  }
}

// Push class in bootstack
arrBootStack.push(Timeline);
